import React, { Component, useState } from "react";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import ChatSupportBtn from "./ChatSupportBtn";
import {
  logout,
  chkapiinput,
  checkTime,
  checkBanner,
  bannertimer,
  generateId,
} from "./Utility";
import moment from "moment";
import Modal from "antd/lib/modal/Modal";
import Calender from "../assets/images/Calender.svg";
import UPI from "../assets/images/upi.svg";
import Clock from "../assets/images/Clock.svg";
import Cash from "../assets/images/cash.JPG";
import Nach from "../assets/images/nach.png";
import customFetch from "./apicall/api";
import { ThemeContext } from "../context/IsLoader";
import {
  PEButton,
  PEDiv,
  PEImg,
  PEInput,
  PESpan,
} from "./permissionComponents";
import { Pagination } from "antd";
import CollectionModal from "./CollectionModal";
import AlternateNumber from './AlternateNumber';

// import $ from "jquery";

const generate_Id1 = generateId(10);
class SearchHousehold extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.sortModal = React.createRef();
    this.listRef = React.createRef();
    this.lastItemRef = null;
    this.observer = null;
    this.pendingLoadMore = false;
    this.lastLoadMoreTime = 0; // Throttle rapid observer triggers
    this.state = {
      items: [],
      cnames: [],
      og_data: [],
      branch_list: [],
      sort_header: "sdemand",
      sort_htl: "low",
      sort_data: [],
      search_text: "",
      uniqueNames: [],
      uniqueLocation: [],
      temp_array: [
        "dFilter1",
        "dFilter2",
        "dFilter3",
        "dFilter4",
        "dFilter5",
        "bFilter1",
        "bFilter2",
        "bFilter3",
        "bFilter4",
        "bFilter5",
        "cFilter1",
        "cFilter2",
        "cFilter3",
        "cFilter4",
        "cFilter5",
        "RF",
        "M",
      ],
      counter: 1,
      searchModal: false,
      isShowName: true,
      isShowLoc: false,
      isShowDem: false,
      isShowBal: false,
      isShowCol: false,
      isLoaded: false,
      isErrOpen: false,
      isHHReg: false,
      isRFnonRF: false,
      api_error_message: "",
      MenuName: "",
      notCalledCount: 0,
      a0: 0,
      a1: 0,
      a2: 1,
      a3: 1,
      a4: 1,
      a5: 1,
      a6: 1,
      b0: 0,
      b1: 0,
      b2: 1,
      b3: 1,
      b4: 1,
      b5: 1,
      b6: 1,
      c0: 0,
      c1: 0,
      c2: 1,
      c3: 1,
      c4: 1,
      c5: 1,
      c6: 1,
      r1: 1,
      r2: 1,
      callsort: 0,
      household_id: "",
      issendQR: false,
      isSmssent: false,
      smsSentmsg: "",
      isSpin: false,
      flag: 0,
      smsmobile: "",
      smsmobileErr: "",
      issmsmobile: false,
      issmsamount: false,
      hhnumber: "",
      isLogout: false,
      time_flag: 0,
      isModalOpen: false,
      isOpenCollect: false,
      historyState: {},
      previous_transactions: [],
      D_count: 0,
      C_count: 0,
      B_count: 0,
      totalDemand: 0,  // Total demand amount from summary API
      totalCollected: 0,  // Total collected amount from summary API
      totalBalance: 0,  // Total balance amount from summary API
      isSummaryLoading: false,  // Loader for summary data while it loads
      isDetailsLoading: false,  // Loader for details/households API (fresh load only)
      isSummaryInitiallyLoaded: false,  // Track if summary API was called at least once
      Full_pay: 0,
      Part_pay: 0,
      No_pay: 0,
      data_filter: "month",
      isDay: false,
      isDate: false,
      isMonth: true,
      collectionmode: [],
      errorMsg: [],
      isOpen: false,
      fliped: false,
      chequeOCRdata: [],
      isReload: true,
      isDisablecollection: false,
      serverflag: "",
      noData:false,
      currentPage: 1,
      pageSize: 20,
      showAlternateNumber: false,
      selectedHouseholdId: '',
      selectedPrimaryMobile: '',
      sortBy:"Demand",
      sortOrder:"asc",
      pageLimit:20,
      pageNumber:1
      ,isLoadingMore: false,
      hasMore: true
    };

    this.handlesort = this.handlesort.bind(this);
    this.handlesorthtl = this.handlesorthtl.bind(this);
    this.handleSearchText = this.handleSearchText.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.filter = this.filter.bind(this);
    this.handleFilterMenu = this.handleFilterMenu.bind(this);
    this.addName = this.addName.bind(this);
    this.handlesortdbc = this.handlesortdbc.bind(this);
    this.handleCallSort = this.handleCallSort.bind(this);
    this.getData = this.getData.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.checkDates = this.checkDates.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // If the list changed, reattach observer to the last item
    if (this.state.cnames.length !== prevState.cnames.length) {
      // disconnect previous observer
      if (this.observer) {
        try { this.observer.disconnect(); } catch (e) {}
        this.observer = null;
      }

      if (!this.listRef || !this.listRef.current) return;
      const root = this.listRef.current;
      const last = this.lastItemRef;
      
      if (!last) {
        return;
      }

      // Only attach observer if we have more data to load
      if (!this.state.hasMore) {
        return;
      }

      // Create observer to watch last item intersecting the viewport
      // root: null means observe relative to viewport, not container
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!this.state.hasMore) {
                return;
              }
              if (this.state.isLoadingMore) {
                return;
              }
              
              // Throttle: only trigger if at least 500ms has passed since last trigger
              const now = Date.now();
              if (now - this.lastLoadMoreTime > 500) {
                this.lastLoadMoreTime = now;
                this.loadMore();
              }
            }
          });
        },
        {
          root: null, // Observe relative to viewport, not container
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      try {
        this.observer.observe(last);
      } catch (e) {
        // ignore if observe fails
      }
    }
  }

  loadMore() {
    if (!this.state.hasMore) {
      return;
    }

    if (this.state.isLoadingMore) {
      // Mark that a load was requested while one was in flight; we'll run another load after current completes
      this.pendingLoadMore = true;
      return;
    }
    
    // disconnect observer to prevent duplicate triggers while loading
    try { if (this.observer) { this.observer.disconnect(); } } catch (e) {}
    // increment page number then fetch
    const nextPage = (this.state.pageNumber || 1) + 1;
    this.setState({ pageNumber: nextPage, isLoadingMore: true }, () => {
      this.fetchDetails(true);
    });
  }

  // handleOkModal = () => {
  //   this.setState({ isModalOpen: false });
  //   this.props.history.push({
  //     pathname: "/CollectionReceipt",
  //     state: {
  //       ...this.state.historyState,
  //     },
  //   });
  // };
  // handleChange = (e) => {
  //   if (e.target.name == "cheque_number") {
  //   } else {
  //     this.setState({
  //       [e.target.name]: e.target.value,
  //     });
  //   }
  //   console.log("change:", e.target.value);
  // };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };
  checkform() {
    let errorMsg = {};
    let isValid = true;
    if (!this.state.payment_method) {
      errorMsg["payment_method"] = "Please select payment mode";
      isValid = false;
    }
    if (this.state.payment_method === "C") {
      if (this.state.total_amt == "" || this.state.total_amt == undefined) {
        errorMsg["total_amt"] = "Please enter amount";
        isValid = false;
      } else if (this.state.total_amt == 0) {
        errorMsg["total_amt"] = "Please enter amount grater than Zero";
        isValid = false;
      } else if (this.state.total_amt < 0) {
        errorMsg["total_amt"] = "Please enter amount";
        isValid = false;
      }
      if (this.state.cash_remark == "" || this.state.cash_remark == undefined) {
        errorMsg["cash_remark"] = "Please enter Remark";
        isValid = false;
      }
    }
    if (this.state.payment_method === "Q") {
      if (this.state.fileupload == "" || this.state.fileupload == undefined) {
        errorMsg["cheque_upload"] = "Please Upload Cheque";
        isValid = false;
      }

      if (this.state.cheque_date == "" || this.state.cheque_date == undefined) {
        errorMsg["cheque_date"] = "Please Enter Cheque Date";
        isValid = false;
      }

      if (this.state.issuer_name == "" || this.state.issuer_name == undefined) {
        errorMsg["issuer_name"] = "Please Enter Issuer Name";
        isValid = false;
      }

      if (
        this.state.issuer_remark == "" ||
        this.state.issuer_remark == undefined
      ) {
        errorMsg["issuer_remark"] = "Please Enter Remark";
        isValid = false;
      }

      if (
        this.state.cheque_amount == "" ||
        this.state.cheque_amount == undefined
      ) {
        errorMsg["cheque_amount"] = "Please enter amount";
        isValid = false;
      } else if (this.state.cheque_amount == 0) {
        errorMsg["cheque_amount"] = "Please enter amount grater than Zero";
        isValid = false;
      } else if (this.state.cheque_amount < 0) {
        errorMsg["cheque_amount"] = "Please enter amount";
        isValid = false;
      }

      if (
        this.state.cheque_number == "" ||
        this.state.cheque_number == undefined
      ) {
        errorMsg["cheque_number"] = "Please Enter Cheque Number";
        isValid = false;
      } else if (this.state.cheque_number.length !== 6) {
        errorMsg["cheque_number"] = "Please Enter Valid Cheque Number";
        isValid = false;
      }
    }

    this.setState({
      errorMsg: errorMsg,
    });

    if (isValid) {
      if (this.state.payment_method === "Q") {
        this.setState({ isSpin: true });
        this.uploadcheque();
      } else if (this.state.payment_method === "L") {
        this.qrsms();
      } else {
        this.setState({
          isOpenCollect: false,
          isDisableBtn: false,
          isOpen: true,
          isSpin:false
        });
      }
    }
  }
  uploadcheque() {
    this.setState({ isOpenCollect: false });
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    const uid = localStorage.getItem("in_userid");

    const formdata = new FormData();
    formdata.append("file", this.state.fileupload);
    formdata.append(
      "blob_url",
      "cheque_collection_by_cso/" + this.state.fileupload.name
    );
    let generate_Id = generateId(10);
    let base_url = process.env.REACT_APP_URL;
    if(this.state.serverflag=="RF"){
      base_url = process.env.REACT_APP_R_URL;
    }
    customFetch(base_url + "/save/files/bucket", {
      method: "POST",
      body: formdata,
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })
      .then((data) => {
        data = data[0];
        if (data.blob_url) {
          // console.log("in_userid", uid);
          // console.log("household_id", this.state.HH_ID);
          // console.log("cheque_dt", this.state.cheque_date);
          // console.log("amount_collected", this.state.cheque_amount);
          // console.log("cheque_number", this.state.cheque_number);
          // console.log("issuer_name", this.state.issuer_name);
          // console.log("remark", this.state.issuer_remark);
          // console.log("filename", this.state.fileupload);
          const formdata = new FormData();
          formdata.append("in_userid", uid);
          formdata.append("household_id", this.state.household_id);
          formdata.append(
            "cheque_date",
            this.state.cheque_date
            //moment(this.state.cheque_date, "YYYY-MM-DD").format("DD-MM-YYYY")
          );
          formdata.append("amount_collected", this.state.cheque_amount);
          formdata.append("cheque_number", this.state.cheque_number);
          formdata.append("issuer_name", this.state.issuer_name);
          formdata.append("remark", this.state.issuer_remark);
          formdata.append("filename", data.blob_url);
          formdata.append("csf", this.state.serverflag);
          formdata.append("product_id", process.env.REACT_APP_PRODUCTID);
          let generate_Id = generateId(10);
          let base_url = process.env.REACT_APP_URL;
          if(this.state.serverflag=="RF"){
            base_url = process.env.REACT_APP_R_URL;
          }
          customFetch(base_url + "/collection/cheque/set", {
            method: "POST",
            body: formdata,
            headers: {
              "api-token": api_token,
              component_id: generate_Id1,
              apiId: generate_Id,
              api_group_id: "",
              component: this.constructor.name,
              user_id: localStorage.getItem("in_userid"),
            },
          })
            .then((res) => {
              if (res.headers.get("api_code") > 0) {
                this.setState({
                  isErrOpen: true,
                  api_error_message: res.headers.get("api_error_message"),
                  isSpin: false,
                });
              }
              return res.json();
            })
            .then((data) => {
              if (data.document_id) {
                this.props.history.push({
                  pathname: "/collectionSuccess",
                  state: {
                    api_token: api_token,
                    tmp_in_amount_collected: this.state.cheque_amount, //data.tmp_in_amount_collected,
                    tmp_txn_ref_no: data.document_id,
                    Household_name: this.state.issuer_name,
                    message: data.message,
                    payment_method: this.state.payment_method,
                    // tmp_in_charges_collected: data.tmp_in_charges_collected,
                    // tmp_timestamp: data.tmp_timestamp,
                    // OcrAmount: this.state.OcrAmount,
                    // OcrBank: this.state.OcrBank,
                    // OcrDate: this.state.OcrDate,
                    // OcrFrom: this.state.OcrFrom,
                    // OcrTo: this.state.OcrTo,
                    // OcrTransaction_ID: this.state.OcrTransaction_ID,
                    // OcrUPI_UTR_Ref: this.state.refno,
                    // Ocrvendor: this.state.Ocrvendor,
                  },
                });
              } else {
                this.setState({
                  isSpin: false,
                  isErrOpen: true,
                  api_error_message: data.message,
                  cheque_txn_ref_no: data.txn_ref_no,
                });
              }
            })
            .catch((error) => {console.log("error", error);this.setState({isSpin: false});});
        } else {
          this.setState({
            isSpin: false,
            isErrOpen: true,
            api_error_message: data.message,
          });
        }
      })
      .catch((error) => {console.log("error", error);this.setState({isSpin: false});});
  }
  checkDates(event) {
    if (event.target.value == "date") {
      this.state.isDate = true;
      this.state.isDay = false;
      this.state.isMonth = false;
    } else if (event.target.value == "day") {
      this.state.isDate = false;
      this.state.isDay = true;
      this.state.isMonth = false;
    } else {
      this.state.isDate = false;
      this.state.isDay = false;
      this.state.isMonth = true;
    }

    this.forceUpdate();
  }

  getData(event) {
    if (event.target.checked) {
      if (event.target.value) {
        this.state.data_filter = event.target.value;
      }
    }
    const { effective_designation_id } =
      (this.props.location && this.props.location.state) || {};
    if((effective_designation_id ==
      process.env.REACT_APP_EFFECTIVE_DESIGNATION_ID_CSO) || (effective_designation_id ==
      process.env.REACT_APP_EFFECTIVE_DESIGNATION_ID_CRO))
    {
      this.fetchDetails();
    }

    // console.log(this.state.data_filter);

    // this.state.sort_header = event.target.value;

    // if (event.target.checked) {
    //   this.state.sort_header = event.target.value;
    // }
    // if(filter === "day"){
    //   this.state.isDay = true;
    //   this.state.isDate = false;
    //   this.state.isMonth = false;
    // }
    // this.forceUpdate();
  }

  handleCancelModal = () => {
    this.setState({ isModalOpen: false });
  };
  handleDataRefresh = () => {
    // Refresh the household data by calling fetchDetails
    return this.fetchDetails().then(() => {
      // After fetching new data, update the details state with the refreshed data for the current household
      if (this.state.details && this.state.details.household_id) {
        const updatedHousehold = this.state.og_data.find(
          item => item.household_id === this.state.details.household_id
        );
        if (updatedHousehold) {
          this.setState({ details: updatedHousehold });
          // Return the fresh data for immediate use
          return updatedHousehold;
        }
      }
      // Return current details if no match found
      return this.state.details;
    });
  };
  handleCallSort(event) {
    let temp = this.state.cnames;
    this.state.sort_data = [];

    // console.log(this.state.cnames);

    if (this.state.callsort == 0) {
      if (this.state.notCalledCount > 0) {
        for (let i = 0; i < this.state.cnames.length; i++) {
          let ncd = new Date(this.state.cnames[i].Next_call_dt);
          let calltime = this.state.cnames[i].call_time;

          if (
            this.state.cnames[i].status === "" ||
            this.state.cnames[i].status === null
          ) {
            this.state.sort_data.push(this.state.cnames[i]);
          } else if (this.state.cnames[i].status === 0) {
            if (
              this.state.cnames[i].Preferred_date === "" ||
              this.state.cnames[i].Preferred_date === null
            ) {
              if (
                new Date().getTime() >
                new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.cnames[i].state === 1) {
            if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
              this.state.sort_data.push(this.state.cnames[i]);
            }
          }
        }
        this.state.cnames = this.state.sort_data;
        this.state.callsort = 1;
      } else {
        this.state.cnames = temp;
      }
    } else {
      this.state.cnames = [];
      this.state.callsort = 0;

      for (let i = 0; i < this.state.og_data.length; i++) {
        if (parseInt(this.state.og_data[i].Balance) > 0) {
          this.state.cnames.push(this.state.og_data[i]);
        }
      }

      if (this.state.counter == 4) {
        if (this.state.temp_array.length > 0) {
          this.state.cnames = [];
          // for (let i = 0; i < this.state.cnames.length; i++) {
          for (let j = 0; j < this.state.temp_array.length; j++) {
            if (this.state.temp_array[j] == "dFilterl0") {
              let notCalledCount = 0;

              for (let i = 0; i < this.state.og_data.length; i++) {
                if (parseInt(this.state.og_data[i].Balance) < 0) {
                  this.state.sort_data.push(this.state.og_data[i]);

                  let ncd = new Date(this.state.og_data[i].Next_call_dt);
                  let calltime = this.state.og_data[i].call_time;

                  if (
                    this.state.og_data[i].status === "" ||
                    this.state.og_data[i].status === null
                  ) {
                    notCalledCount += 1;
                  } else if (this.state.og_data[i].status === 0) {
                    if (
                      this.state.og_data[i].Preferred_date === "" ||
                      this.state.og_data[i].Preferred_date === null
                    ) {
                      if (
                        new Date().getTime() >
                        new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                      ) {
                        notCalledCount += 1;
                      }
                    }
                  } else if (this.state.og_data[i].state === 1) {
                    if (
                      new Date(calltime).getTime() > new Date(ncd).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                }
              }
              this.state.notCalledCount = notCalledCount;
            } else if (this.state.temp_array[j] == "dFilter0") {
              let notCalledCount = 0;

              for (let i = 0; i < this.state.og_data.length; i++) {
                if (parseInt(this.state.og_data[i].Balance) == 0) {
                  this.state.sort_data.push(this.state.og_data[i]);
                  if (
                    new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
                    this.state.og_data[i].status == null
                  ) {
                    this.state.og_data[i].isCalled = false;

                    this.state.og_data[i].isCallDetailsAdded = false;

                    notCalledCount += 1;
                  } else if (
                    new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
                    this.state.og_data[i].status != null
                  ) {
                    this.state.og_data[i].isCalled = true;

                    this.state.og_data[i].isCallDetailsAdded = false;
                  } else if (
                    new Date() < new Date(this.state.og_data[i].Next_call_dt)
                  ) {
                    this.state.og_data[i].isCalled = true;

                    this.state.og_data[i].isCallDetailsAdded = true;
                  }
                }
              }
              this.state.notCalledCount = notCalledCount;
            } else if (this.state.temp_array[j] == "dFilter1") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseInt(this.state.og_data[i].Balance) >= 1 &&
                  parseInt(this.state.og_data[i].Balance) <= 2000
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter2") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseInt(this.state.og_data[i].Balance) >= 2001 &&
                  parseInt(this.state.og_data[i].Balance) <= 3999
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter3") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseInt(this.state.og_data[i].Balance) >= 4000 &&
                  parseInt(this.state.og_data[i].Balance) <= 6999
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter4") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseInt(this.state.og_data[i].Balance) >= 7000 &&
                  parseInt(this.state.og_data[i].Balance) <= 9000
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter5") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (parseInt(this.state.og_data[i].Balance) >= 9001) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            }
          }
          // }
          this.state.cnames = this.state.sort_data;
        } else {
          this.state.cnames = this.state.og_data;
        }
      }
    }

    this.forceUpdate();
  }

  fetchDetails() {
    // default behaviour: full refresh (replace). To append, call fetchDetails(true)
    const append = arguments.length > 0 && arguments[0] === true;
    // For append (lazy load) use isLoadingMore; for fresh loads use isDetailsLoading
    if (append) {
      this.setState({ isLoadingMore: true });
    } else {
      this.setState({ isSpin: true });
    }

    const uid = localStorage.getItem("in_userid");
    if (!uid) {
      this.setState({ isLogout: true, isSpin: false });
      return;
    }
    const { api_token, effective_designation_id } =
      (this.props.location && this.props.location.state) || {};
    /*Check if data is null then logout*/
    var arr = [uid, effective_designation_id];
    var chkdata = chkapiinput(arr);
    if (chkdata === false) {
      this.setState({ isSpin: false });
      setTimeout(function() {
        logout();
      }, 2000);
    }

    // choose page_number depending on whether we're appending or doing a fresh load
    const pageNumberToUse = append ? this.state.pageNumber : 1;
    const params = {
      in_userid: uid,
      effective_designation_id: effective_designation_id,
      household_number: this.state.hhnumber,
      record_flag: this.state.data_filter,
      order_by: this.state.sortBy,
      sort_order: this.state.sortOrder,
      page_limit: this.state.pageLimit,
      page_number: pageNumberToUse
    };
    if (this.state.hhnumber) {
      params["household_number"] = this.state.hhnumber;
    }
    const queryParams = new URLSearchParams(params).toString();
    let generate_Id = generateId(10);
    
    // Only call summary API on fresh loads (search/sort), NOT on lazy-load scroll
    if (append) {
      // Lazy-load: only call details API
      customFetch(
        process.env.REACT_APP_URL + "/details/households/all?" + queryParams,
        {
          method: "GET",
          headers: {
            "api-token": api_token,
            component_id: generate_Id1,
            apiId: generate_Id,
            api_group_id: "",
            component: this.constructor.name,
            user_id: uid,
          },
        }
      )
        .then((res) => {
          if (res.headers.get("api_code") > 0) {
            this.setState({
              // commented below code so that lazy loader will not show -no content popup 
              // isErrOpen: true,
              // api_error_message: res.headers.get("api_error_message"),
              isLoadingMore: false,
              isReload: false,
            });
          }
          return res.json();
        })
        .then((detailsJson) => {
          // For lazy-load, only process details (no summary)
          this.setState({ isLoadingMore: false }, () => {
            this.processFetchResponse(detailsJson, null, append);
          });
        })
        .catch((error) => {
          this.setState({ isLoadingMore: false }, () => {
            if (this.pendingLoadMore) {
              this.pendingLoadMore = false;
              setTimeout(() => this.loadMore(), 50);
            }
          });
        });
    } else {
      // Fresh load (search/sort): call both APIs independently
      // Details API will load first (has pagination), Summary API loads in background
      const summaryParams = {
        in_userid: uid,
        record_flag: this.state.data_filter
      };

      if (
        // effective_designation_id ==
        // process.env.REACT_APP_EFFECTIVE_DESIGNATION_ID_CSO
        !localStorage.getItem("hh_mapped_collection_users").split(",").includes(
          effective_designation_id.toString()
        )
      ) {
        if (this.state.hhnumber) {
          summaryParams["household_number"] = this.state.hhnumber;
        }
      }
      const summaryQueryParams = new URLSearchParams(summaryParams).toString();
      let generate_Id_summary = generateId(10);

      // Check if we should skip summary API call for this user
      // Skip if: user is NOT in hh_mapped_collection_users list AND summary was already loaded initially
      const shouldSkipSummaryAPI = 
        localStorage.getItem("hh_mapped_collection_users").split(",").includes(effective_designation_id.toString()) 
        && this.state.isSummaryInitiallyLoaded;

      // Set loading state for details API (always called on fresh load)
      this.setState({ isDetailsLoading: true });

      // DETAILS API - Call independently, process response immediately when ready
      customFetch(
        process.env.REACT_APP_URL + "/details/households/all?" + queryParams,
        {
          method: "GET",
          headers: {
            "api-token": api_token,
            component_id: generate_Id1,
            apiId: generate_Id,
            api_group_id: "",
            component: this.constructor.name,
            user_id: uid,
          },
        }
      )
        .then((res) => {
          if (res.headers.get("api_code") > 0) {
            this.setState({
              // commented below code so that lazy loader will not show -no content popup 
              // isErrOpen: true,
              // api_error_message: res.headers.get("api_error_message"),
              isDetailsLoading: false,
              isReload: false,
            });
          }
          return res.json();
        })
        .then((detailsJson) => {
          // Process details immediately - show household list right away
          // Pass null for summary since it's still loading
          // Clear details loading flag so list shows, but summary skeleton remains
          this.setState({ isDetailsLoading: false }, () => {
            this.processFetchResponse(detailsJson, null, append);
          });
        })
        .catch((error) => {
          console.error("Details API error:", error);
          this.setState({ isDetailsLoading: false }, () => {
            if (this.pendingLoadMore) {
              this.pendingLoadMore = false;
              setTimeout(() => this.loadMore(), 50);
            }
          });
        });

      // SUMMARY API - Call independently in background (conditionally)
      if (!shouldSkipSummaryAPI) {
        // Reset summary data and show loading indicator
        this.setState({ 
          isSummaryLoading: true,
          totalDemand: 0,
          totalCollected: 0,
          totalBalance: 0,
          B_count: 0,
          C_count: 0,
          D_count: 0,
          Full_pay: 0,
          Part_pay: 0,
          No_pay: 0
        });
        
        customFetch(
          process.env.REACT_APP_URL + "/collection/dashboard/summary?" + summaryQueryParams,
          {
            method: "GET",
            headers: {
              "api-token": api_token,
              component_id: generate_Id1,
              apiId: generate_Id_summary,
              api_group_id: "",
              component: this.constructor.name,
              user_id: uid,
            },
          }
        )
          .then((res) => res.json())
          .then((summaryJson) => {
            // Process only summary data when it arrives
            this.processSummaryResponse(summaryJson);
          })
          .catch((error) => {
            console.error("Summary API error:", error);
            // Clear loading flag even on error
            this.setState({ isSummaryLoading: false, isDetailsLoading: false });
          });
      }
      // If skipped, summary data persists from initial load
    }
  }

  processFetchResponse(detailsJson, summaryJson, append) {
    // Update summary data ONLY if provided (fresh loads have it, lazy-loads don't)
    
    // Handle both object and array responses from summary API
    let summary = null;
    if (summaryJson) {
      // If it's an array, take first element; if it's an object, use directly
      summary = Array.isArray(summaryJson) ? summaryJson[0] : summaryJson;
    }
    
    if (summary && summary.Demand) {
      const newDemand = parseFloat(summary.Demand) || 0;
      const newCollected = parseFloat(summary.Collected) || 0;
      const newBalance = parseFloat(summary.Balance) || 0;
      // Parse as numbers to ensure proper formatting in UI
      this.setState({
        totalDemand: newDemand,
        totalCollected: newCollected,
        totalBalance: newBalance,
      });
    } else {
    }

    // Handle both object and array responses from details API
    let details = null;
    if (detailsJson) {
      // If it's an array, take first element; if it's an object, use directly
      details = Array.isArray(detailsJson) ? detailsJson[0] : detailsJson;
    }

    // Process details (household list) based on append vs fresh load
    if (details.api_code === 4 || details.api_code === 3 || details.api_code === 5) {
      localStorage.clear();
      this.props.history.push("/");
    }
    
    if (!append) {
      // fresh load (e.g., filters changed or initial load)
      this.state.cnames = [];
      // reset pagination when doing fresh load
      // NOTE: Don't reset totalDemand/totalCollected/totalBalance here - let summary API manage those
      this.setState({
        isSpin: false,
        hasMore: true,
        pageNumber: 1
      });
    } else {
      // when appending we still keep the main spinner unaffected but clear loading-more flag
      this.setState({ isLoadingMore: false }, () => {
        // if another loadMore was requested while we were loading, perform it now
        if (this.pendingLoadMore) {
          this.pendingLoadMore = false;
          // schedule slightly later to avoid deep recursion / sync re-entry
          setTimeout(() => {
            this.loadMore();
          }, 50);
        }
      });
    }
    
    if (details.Branches && details.Branches.length > 0) {
      let notCalledCount = 0;

      var temp = []
        .concat(details.Branches)
        .sort((a, b) => a.HH_ID == b.HH_ID);

      // temp.forEach((element) => {
      //   if (element.Balance > 0 && element.Demand > 0) {
      //     this.state.B_count = this.state.B_count + 1;
      //   } else if (element.Balance <= 0 && element.Demand > 0) {
      //     this.state.Full_pay = this.state.Full_pay + 1;
      //   }
      //   if (element.Collected == 0 && element.Demand > 0) {
      //     this.state.No_pay = this.state.No_pay + 1;
      //   }
      //   if (element.Demand > 0) {
      //     // Only increment D_count if summary API didn't provide it (lazy-load scenario)
      //     if (!summaryJson) {
      //       console.log("Incrementing D_count (no summaryJson)");
      //       this.state.D_count = this.state.D_count + 1;
      //     } else {
      //       console.log("Skipping D_count increment (summaryJson exists)");
      //     }
      //     if (element.Collected > 0 && element.Balance > 0) {
      //       this.state.Part_pay = this.state.Part_pay + 1;
      //     }
      //   }
      //   if (element.Collected > 0) {
      //     // Only increment C_count if summary API didn't provide it (lazy-load scenario)
      //     if (!summaryJson) {
      //       console.log("Incrementing C_count (no summaryJson)");
      //       this.state.C_count = this.state.C_count + 1;
      //     } else {
      //       console.log("Skipping C_count increment (summaryJson exists)");
      //     }
      //   }
      // });
      


      // ⚠️ IMPORTANT: Do NOT push into this.state.cnames here!
      // Let the setState logic below handle cnames (append vs replace)
      const returnedBranches = details.Branches || [];
      
      // If appended call, we assume pageNumber already incremented by caller
      if (append) {
        // Keep calling API until we get zero results (no more data to fetch)
        const hasMore = returnedBranches.length > 0;
        const newCnames = [...this.state.cnames, ...returnedBranches];
        this.setState({
          isSpin: false,
          isLoaded: true,
          cnames: newCnames,
          items: details,
          og_data: details.Branch_list || [],
          notCalledCount: notCalledCount,
          isLoadingMore: false,
          hasMore: hasMore
        });
      } else {
        // Fresh load: set cnames to the returned branches
        this.setState({
          isSpin: false,
          isLoaded: true,
          cnames: returnedBranches,
          items: details,
          og_data: details.Branch_list || [],
          notCalledCount: notCalledCount,
          hasMore: true
        });
      }

    } else {
      // No branches returned
      if (append) {
        // Append: mark no more pages and clear loading flag
        this.setState({ isLoadingMore: false, hasMore: false }, () => {
          if (this.pendingLoadMore) {
            this.pendingLoadMore = false;
            setTimeout(() => this.loadMore(), 50);
          }
        });
      } else {
        // Fresh load: clear spinner and loading state to show "no results" message
        this.setState({ 
          isSpin: false, 
          hasMore: false,
          isDetailsLoading: false,
          cnames: [],
          isLoaded: true
        });
      }
    }
  }

  processSummaryResponse(summaryJson) {
    // Process only summary data when it arrives (called independently from details API)
    // Handle both object and array responses from summary API
    let summary = null;
    if (summaryJson) {
      // If it's an array, take first element; if it's an object, use directly
      summary = Array.isArray(summaryJson) ? summaryJson[0] : summaryJson;
    }
    
    if (summary && summary.Demand) {
      const newDemand = parseFloat(summary.Demand) || 0;
      const newCollected = parseFloat(summary.Collected) || 0;
      const newBalance = parseFloat(summary.Balance) || 0;
      
      // Update summary amounts, stop loading, and mark summary as initially loaded
      this.setState({
        totalDemand: newDemand,
        totalCollected: newCollected,
        totalBalance: newBalance,
        B_count: summary.B_count,
        Full_pay: summary.Full_pay,
        No_pay: summary.No_pay,
        D_count: summary.D_count,
        Part_pay: summary.Part_pay,
        C_count: summary.C_count,
        isSummaryLoading: false,
        isSummaryInitiallyLoaded: true  // Mark that summary was loaded at least once
      });
    } else {
      this.setState({ 
        isSummaryLoading: false,
        isSummaryInitiallyLoaded: true  // Mark as loaded even if no data
      });
    }
  }

  componentDidMount() {
    if (
      window.Android &&
      typeof window.Android.getDataFromLocalStorage === "function"
    ) {
      const data = window.Android.getDataFromLocalStorage("your_key");
      if (data) {
        this.setState({ isSpin: false, flag: 1 }); // Set flag to 1 if accessed from Android
        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });

        console.log("AndroidInterface->", data);
      }
    } else {
      console.log(
        "Error in AndroidInterface: Android method not found or not available."
      );
    }

    document.title = "Search Household";
    //AT-1659 | AT-1767 | Ankur Makavana | 05-07-2023 | store ui performance data
    setTimeout(() => {
      if (document.readyState === "complete") {
        this.context.onPageLoad({
          component: this.constructor.name,
          component_id: generate_Id1,
        });
      } else {
        window.addEventListener("load", this.context.onPageLoad());
        this.cleanup = () =>
          window.removeEventListener("load", this.context.onPageLoad());
      }
    }, 1000);
    if (checkTime() !== false) {
      this.state.time_flag = 1;
      this.setState({ isSpin: false, maintaenance: checkTime() });
    }
    if (checkBanner() != false) {
      const interval = setInterval(() => {
        this.setState({
          banner_timer: bannertimer(),
        });
      }, 1000);
      this.setState({
        maintaenanceBanner: true,
        maintaenanceBannerText: checkBanner(),
      });
    }
    const { api_token, effective_designation_id } =
      (this.props.location && this.props.location.state) || {};
    // if (
    //   // effective_designation_id ==
    //   // process.env.REACT_APP_EFFECTIVE_DESIGNATION_ID_CSO
    //   localStorage.getItem("hh_mapped_collection_users").split(",").includes(
    //     effective_designation_id.toString()
    //   )
    // ) {
    //   this.fetchDetails();
    // }
    this.fetchDetails();
    console.log("Today", moment().format("DD:H"));
    //this.checkTime();
    // this.forceUpdate();
    this.getcollectionmode();
  }
  
  getcollectionmode() {
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    let generate_Id = generateId(10);
    let base_url = process.env.REACT_APP_URL;
    if(this.state.serverflag=="RF"){
      base_url = process.env.REACT_APP_R_URL;
    }
    customFetch(
      base_url + "/check/collectionmodeflag/upi/status",
      {
        method: "GET",
        headers: {
          "api-token": api_token,
          component_id: generate_Id1,
          apiId: generate_Id,
          api_group_id: "",
          component: this.constructor.name,
          user_id: localStorage.getItem("in_userid"),
        },
        //   body: formdata,
      }
    )
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isSpin: false,
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
          });
        }
        return res.json();
      })

      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        this.setState({
          collectionmode: json,
        });
      })
      .catch((error) => {console.log("error", error);this.setState({isSpin: false});});
  }
  handleCheckpaymethod(e) {
    this.setState({
      payment_method: e,
      errorMsg: "",
      fileupload: "",
      issuer_name: "",
      cheque_date: "",
      cheque_number: "",
      cheque_amount: "",
      issuer_remark: "",
      total_amt: "",
      totpay: "",
      cash_remark: "",
    });
    if (e != "Q") {
      this.setState({
        isDisablecollection: true,
      });
    } 
    // else {
    //   this.setState({
    //     isDisablecollection: false,
    //   });
    // }
    if (e === "") {
      this.setState({ fliped: false });
    } else {
      this.setState({ fliped: !this.state.fliped });
    }
  }
  setDateTime = function(date, str) {
    var sp = str.split(":");
    date.setHours(parseInt(sp[0], 10));
    date.setMinutes(parseInt(sp[1], 10));
    date.setSeconds(parseInt(sp[2], 10));
    return date;
  };
  // checkTime() {
  //   var d = new Date();
  //   let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
  //   let mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
  //   var current,
  //     startTime,
  //     currentend,
  //     endTime = "";
  //   if (moment("01/" + mo + "/" + ye).format("ddd") === "Fri") {
  //     current = new Date("01/" + mo + "/" + ye);
  //     startTime = this.setDateTime(new Date(current), "17:30:00");
  //     //currentend = new Date("02/" + mo + "/" + ye);
  //     currentend = new Date("01/" + mo + "/" + ye);
  //     endTime = this.setDateTime(new Date(currentend), "19:00:00");
  //   } else {
  //     current = new Date("02/" + mo + "/" + ye);
  //     startTime = this.setDateTime(new Date(current), "17:30:00");
  //     //currentend = new Date("03/" + mo + "/" + ye);
  //     currentend = new Date("02/" + mo + "/" + ye);
  //     endTime = this.setDateTime(new Date(currentend), "19:00:00");
  //   }
  //   if (d > startTime.getTime() && d < endTime.getTime()) {
  //     this.state.time_flag = 1;
  //     this.setState({ isSpin: false });
  //   } else {
  //     this.state.time_flag = 0;
  //   }
  // }
  handleFilterMenu(event) {
    if (event.currentTarget.id == "nameFilter") {
      this.state.counter = 1;
      this.state.MenuName = "Name";
      this.state.isShowName = true;
      this.state.isShowLoc = false;
      this.state.isShowDem = false;
      this.state.isShowBal = false;
      this.state.isShowCol = false;
      this.state.isRFnonRF = false;
    } else if (event.currentTarget.id == "locationFilter") {
      this.state.counter = 2;
      this.state.MenuName = "Location";
      this.state.isShowName = false;
      this.state.isShowLoc = true;
      this.state.isShowDem = false;
      this.state.isShowBal = false;
      this.state.isShowCol = false;
      this.state.isRFnonRF = false;
    } else if (event.currentTarget.id == "demandFilter") {
      this.state.counter = 3;
      this.state.MenuName = "Demand";
      this.state.isShowName = false;
      this.state.isShowLoc = false;
      this.state.isShowDem = true;
      this.state.isShowBal = false;
      this.state.isShowCol = false;
      this.state.isRFnonRF = false;
    } else if (event.currentTarget.id == "balFilter") {
      this.state.counter = 4;
      this.state.MenuName = "Balance";
      this.state.isShowName = false;
      this.state.isShowLoc = false;
      this.state.isShowDem = false;
      this.state.isShowBal = true;
      this.state.isShowCol = false;
      this.state.isRFnonRF = false;
    } else if (event.currentTarget.id == "colFilter") {
      this.state.counter = 5;
      this.state.MenuName = "Collection";
      this.state.isShowName = false;
      this.state.isShowLoc = false;
      this.state.isShowDem = false;
      this.state.isShowBal = false;
      this.state.isShowCol = true;
      this.state.isRFnonRF = false;
    } else if (event.currentTarget.id == "rfandnonrf") {
      this.state.counter = 6;
      this.state.MenuName = "RF / Non RF";
      this.state.isShowName = false;
      this.state.isShowLoc = false;
      this.state.isShowDem = false;
      this.state.isShowBal = false;
      this.state.isShowCol = false;
      this.state.isRFnonRF = true;
    }
    this.forceUpdate();
  }
  registerhousehold(hhid) {
    console.log(hhid);
    this.setState({
      isHHReg: true,
      household_id: hhid,
    });
  }
  sendqrsms(
    hhid,
    mobile,
    Balance,
    Charges_os,
    emi,
    Loan_os,
    hh_name,
    household_number
  ) {
    console.log(hhid);
    //Maximum amount - min(max((balance + charges_os), emi), (loan_os + charges_os))
    var clc1 = parseInt(Balance) + parseInt(Charges_os);
    var clc2 = parseInt(Loan_os) + parseInt(Charges_os);
    var getmax, getmin;
    if (clc1 > emi) {
      getmax = clc1;
    } else {
      getmax = emi;
    }
    if (clc2 < getmax) {
      getmin = clc2;
    } else {
      getmin = getmax;
    }

    var max_paylink = getmin;
    var totamt = parseInt(Balance) + parseInt(Charges_os);
    if (totamt == 0) {
      this.setState({
        issmsamount: true,
        smsamountErr:
          "You can not send payment link for 0 (zero) amount. Please change the amount.",
      });
    } else {
      this.setState({
        issmsamount: false,
        smsamountErr: "",
      });
    }
    this.setState({
      issendQR: true,
      household_id: hhid,
      smsmobile: mobile,
      totamt: totamt,
      totpay: totamt,
      smsread: true,
      amountread: true,
      max_paylink: max_paylink,
      hh_name: hh_name,
      household_number: household_number,
    });
  }
  qrsms() {
    this.setState({
      issendQR: false,
      isSpin: true,
    });
    const { api_token, household_id } =
      (this.props.location && this.props.location.state) || {};
    /*Check if data is null then logout*/
    var arr = [this.state.household_id, this.state.smsmobile];
    var chkdata = chkapiinput(arr);
    if (chkdata === false) {
      this.setState({ isSpin: false });
      setTimeout(function() {
        logout();
      }, 2000);
    }
    const uid = localStorage.getItem("in_userid");
    const formdata = new FormData();
    formdata.append("household_id", this.state.household_id);
    formdata.append("mobile_no", this.state.smsmobile);
    formdata.append("amount", this.state.totpay);
    formdata.append("created_by_id", uid);
    formdata.append("created_mode", "A");
    formdata.append("csf", this.state.serverflag);
    formdata.append("product_id", process.env.REACT_APP_PRODUCTID);
    let generate_Id = generateId(10);
    let base_url = process.env.REACT_APP_URL;
    if(this.state.serverflag=="RF"){
      base_url = process.env.REACT_APP_R_URL;
    }
    customFetch(base_url + "/create/upi/payment/link", {
      method: "POST",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
      body: formdata,
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        console.log(json);

        if (json.short_url) {
          this.setState({
            isSmssent: true,
            isSpin: false,
            smsSentmsg:
              `Payment Link <a href="` +
              json.short_url +
              `"> ` +
              json.short_url +
              ` </a> is Sent Successfully! <br/> अगर यह लिंक ` +
              this.state.Lead_Name +
              ` जी को SMS से प्राप्त नही हुआ है, तभी यह लिंक सिर्फ उनको ही प्रदान करने का कष्ट करे। <b>कृपया यह लिंक दूसरे हाउसहोल्ड को ना भेजें।</b> `,
          });
        } else {
          this.setState({
            isSmssent: true,
            isSpin: false,
            smsSentmsg:
              "Payment Link is Not Sent. Please try again after some time.",
          });
        }
      })
      .catch((error) => {console.log("error", error);this.setState({isSpin: false});});
  }
  addName(event) {
    if (event.target.checked) {
      this.state.temp_array.push(event.target.id);
      if (event.target.id == "dFilter1") {
        this.state.a2 = 1;
      } else if (event.target.id == "dFilter2") {
        this.state.a3 = 1;
      } else if (event.target.id == "dFilter3") {
        this.state.a4 = 1;
      } else if (event.target.id == "dFilter4") {
        this.state.a5 = 1;
      } else if (event.target.id == "dFilter5") {
        this.state.a6 = 1;
      } else if (event.target.id == "dFilter0") {
        this.state.a0 = 1;
      } else if (event.target.id == "dFilter10") {
        this.state.a1 = 1;
      }
      if(event.target.id == "RF"){
        this.state.r1 = 1;
      }
      if(event.target.id == "M"){
        this.state.r2 = 1;
      }
      if (event.target.id == "bFilter1") {
        this.state.b2 = 1;
      } else if (event.target.id == "bFilter2") {
        this.state.b3 = 1;
      } else if (event.target.id == "bFilter3") {
        this.state.b4 = 1;
      } else if (event.target.id == "bFilter4") {
        this.state.b5 = 1;
      } else if (event.target.id == "bFilter5") {
        this.state.b6 = 1;
      } else if (event.target.id == "bFilter0") {
        this.state.b0 = 1;
      } else if (event.target.id == "bFilter10") {
        this.state.b1 = 1;
      }

      if (event.target.id == "cFilter1") {
        this.state.c2 = 1;
      } else if (event.target.id == "cFilter2") {
        this.state.c3 = 1;
      } else if (event.target.id == "cFilter3") {
        this.state.c4 = 1;
      } else if (event.target.id == "cFilter4") {
        this.state.c5 = 1;
      } else if (event.target.id == "cFilter5") {
        this.state.c6 = 1;
      } else if (event.target.id == "cFilter0") {
        this.state.c0 = 1;
      } else if (event.target.id == "cFilter10") {
        this.state.c1 = 1;
      }
    } else {
      for (let i = 0; i < this.state.temp_array.length; i++) {
        if (event.target.id == this.state.temp_array[i]) {
          this.state.temp_array.splice(i, 1);
          if (event.target.id == "dFilter1") {
            this.state.a2 = 0;
          } else if (event.target.id == "dFilter2") {
            this.state.a3 = 0;
          } else if (event.target.id == "dFilter3") {
            this.state.a4 = 0;
          } else if (event.target.id == "dFilter4") {
            this.state.a5 = 0;
          } else if (event.target.id == "dFilter5") {
            this.state.a6 = 0;
          } else if (event.target.id == "dFilter0") {
            this.state.a0 = 0;
          } else if (event.target.id == "dFilter10") {
            this.state.a1 = 0;
          }
          if(event.target.id == "RF"){
            this.state.r1 = 0;
          }
          if(event.target.id == "M"){
            this.state.r2 = 0;
          }
          if (event.target.id == "bFilter1") {
            this.state.b2 = 0;
          } else if (event.target.id == "bFilter2") {
            this.state.b3 = 0;
          } else if (event.target.id == "bFilter3") {
            this.state.b4 = 0;
          } else if (event.target.id == "bFilter4") {
            this.state.b5 = 0;
          } else if (event.target.id == "bFilter5") {
            this.state.b6 = 0;
          } else if (event.target.id == "bFilter0") {
            this.state.b0 = 0;
          } else if (event.target.id == "bFilter10") {
            this.state.b1 = 0;
          }

          if (event.target.id == "cFilter1") {
            this.state.c2 = 0;
          } else if (event.target.id == "cFilter2") {
            this.state.c3 = 0;
          } else if (event.target.id == "cFilter3") {
            this.state.c4 = 0;
          } else if (event.target.id == "cFilter4") {
            this.state.c5 = 0;
          } else if (event.target.id == "cFilter5") {
            this.state.c6 = 0;
          } else if (event.target.id == "cFilter0") {
            this.state.c0 = 0;
          } else if (event.target.id == "cFilter10") {
            this.state.c1 = 0;
          }
        }
      }
    }
    console.log(this.state.temp_array);
    this.forceUpdate();
    //
  }

  filter(event) {
    this.state.sort_data = [];

    this.state.cnames = this.state.og_data;

    this.state.callsort = 0;

    if (this.state.counter == 1) {
      if (this.state.temp_array.length > 0) {
        for (let i = 0; i < this.state.cnames.length; i++) {
          for (let j = 0; j < this.state.temp_array.length; j++) {
            if (
              this.state.cnames[i].Lead_Name.toLowerCase().indexOf(
                this.state.temp_array[j].toLowerCase()
              ) == 0
            ) {
              this.state.sort_data.push(this.state.cnames[i]);
            }
          }
        }
        this.state.cnames = this.state.sort_data;
      } else {
        this.state.cnames = this.state.og_data;
      }
    } else if (this.state.counter == 2) {
      if (this.state.temp_array.length > 0) {
        for (let i = 0; i < this.state.cnames.length; i++) {
          for (let j = 0; j < this.state.temp_array.length; j++) {
            if (
              this.state.cnames[i].Location_Name.toLowerCase().indexOf(
                this.state.temp_array[j].toLowerCase()
              ) == 0
            ) {
              this.state.sort_data.push(this.state.cnames[i]);
            }
          }
        }
        this.state.cnames = this.state.sort_data;
      } else {
        this.state.cnames = this.state.og_data;
      }
    } else if (this.state.counter == 3 || this.state.counter == 5) {
      if (this.state.temp_array.length > 0) {
        for (let j = 0; j < this.state.temp_array.length; j++) {
          if (this.state.temp_array[j] == "dFilter1") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) >=
                  0 &&
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) <=
                  2000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter2") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) >=
                  2001 &&
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) <=
                  3999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter3") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) >=
                  4000 &&
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) <=
                  6999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter4") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) >=
                  7000 &&
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) <=
                  9000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter5") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) >=
                9001
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter10") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) <
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Demand) +
                  parseInt(this.state.cnames[i].other_charges_due) ==
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          }

          if (this.state.temp_array[j] == "cFilter1") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) >=
                  0 &&
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) <=
                  2000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter2") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) >=
                  2001 &&
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) <=
                  3999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter3") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) >=
                  4000 &&
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) <=
                  6999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter4") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) >=
                  7000 &&
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) <=
                  9000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter5") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) >=
                9001
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter10") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) <
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Collected) +
                  parseInt(this.state.cnames[i].Other_charges_rcvd) ==
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          }
        }
      } else {
        this.state.cnames = this.state.og_data;
      }
    } else if (this.state.counter == 4) {
      let notCalledCount = 0;
      console.log("Balance");
      if (this.state.temp_array.length > 0) {
        // for (let i = 0; i < this.state.cnames.length; i++) {
        for (let j = 0; j < this.state.temp_array.length; j++) {
          if (this.state.temp_array[j] == "bFilterl0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) <
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);

                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
            // this.state.notCalledCount = notCalledCount;
          } else if (this.state.temp_array[j] == "bFilter0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) ==
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
            // this.state.notCalledCount = notCalledCount;
          } else if (this.state.temp_array[j] == "bFilter1") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) >=
                  1 &&
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) <=
                  2000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter2") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) >=
                  2001 &&
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) <=
                  3999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter3") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) >=
                  4000 &&
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) <=
                  6999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter4") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) >=
                  7000 &&
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) <=
                  9000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter5") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseInt(this.state.cnames[i].Balance) +
                  parseInt(this.state.cnames[i].Charges_os) >=
                9001
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          }
        }
        this.state.notCalledCount = notCalledCount;
        // }
        this.state.cnames = this.state.sort_data;
      } else {
        this.state.cnames = this.state.og_data;
      }
    } else if (this.state.counter == 6) {
      if (this.state.temp_array.length > 0) {
        console.log("counter-6",this.state.cnames);
        for (let i = 0; i < this.state.cnames.length; i++) {
          for (let j = 0; j < this.state.temp_array.length; j++) {
            //console.log("counter-6",this.state.cnames[i].csf.toLowerCase()+ i +'-'+ this.state.temp_array[j].toLowerCase());
            if (
              this.state.cnames[i].csf.toLowerCase().indexOf(
                this.state.temp_array[j].toLowerCase()
              ) == 0
            ) {
              this.state.sort_data.push(this.state.cnames[i]);
            }
          }
        }
        this.state.cnames = this.state.sort_data;
      } else {
        this.state.cnames = this.state.og_data;
      }
    }

    console.log(this.state.temp_array);
    console.log(this.state.cnames);
    this.forceUpdate();
  }

  handleSearchText(event) {
    this.state.search_text = event.target.value;

    // if (this.state.search_text == "") {
    //   this.state.cnames = [];
    //   let notCalledCount = 0;
    //   for (let i = 0; i < this.state.og_data.length; i++) {
    //     if (parseInt(this.state.og_data[i].Balance) > 0) {
    //       this.state.cnames.push(this.state.og_data[i]);
    //       if (
    //         new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
    //         this.state.og_data[i].status == null
    //       ) {
    //         this.state.og_data[i].isCalled = false;
    //         this.state.og_data[i].isCallDetailsAdded = false;
    //         notCalledCount += 1;
    //       } else if (
    //         new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
    //         this.state.og_data[i].status != null
    //       ) {
    //         this.state.og_data[i].isCalled = true;

    //         this.state.og_data[i].isCallDetailsAdded = false;
    //       } else if (
    //         new Date() < new Date(this.state.og_data[i].Next_call_dt)
    //       ) {
    //         this.state.og_data[i].isCalled = true;

    //         this.state.og_data[i].isCallDetailsAdded = true;
    //       }
    //     }
    //   }
    //   this.state.notCalledCount = notCalledCount;
    //   this.forceUpdate();
    // }
  }

  searchCustomer(event) {
    // Same functionality as hhnumber search button
    // Set the search text as hhnumber and call fetchDetails to get fresh data from API
    this.setState({
      hhnumber: this.state.search_text,
      pageNumber: 1,
      cnames: []
    }, () => {
      console.log('🔍 Search customer clicked with text:', this.state.search_text);
      this.fetchDetails(); // Fresh load with search parameter
    });
  }

  handlesort(event) {
    // ✅ NEW: Backend sorting via API
    // Map the radio button values to API parameters
    const sortMap = {
      'sdemand': 'demand',
      'sbalanced': 'balance',
      'scollected': 'collection'
    };

    // Convert sort order: "high" -> "desc", "low" -> "asc"
    const sortOrderMap = {
      'high': 'desc',
      'low': 'asc'
    };

    const newSortBy = sortMap[this.state.sort_header] || 'demand';
    const newSortOrder = sortOrderMap[this.state.sort_htl] || 'asc';

    console.log('🔄 Apply sort clicked', {
      sort_header: this.state.sort_header,
      sort_htl: this.state.sort_htl,
      mappedSortBy: newSortBy,
      mappedSortOrder: newSortOrder
    });

    // Update state with new sort params and fetch with page 1
    this.setState({
      sortBy: newSortBy,
      sortOrder: newSortOrder,
      pageNumber: 1,
      cnames: [] // Clear existing list for fresh sort
    }, () => {
      console.log('✅ Sort params updated, calling fetchDetails');
      this.fetchDetails(); // Fresh load with new sort params
    });

    /* ❌ OLD CLIENT-SIDE SORTING (DEPRECATED - kept for reference)
    if (this.state.sort_header == "sdemand") {
      if (this.state.sort_htl == "high") {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseInt(b.Demand) +
              parseInt(b.other_charges_due) -
              (parseInt(a.Demand) + parseInt(a.other_charges_due))
          );

        this.state.cnames = this.state.sort_data;
        // console.log(this.state.sort_data);
        this.forceUpdate();
      } else {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseInt(a.Demand) +
              parseInt(a.other_charges_due) -
              (parseInt(b.Demand) + parseInt(b.other_charges_due))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      }
    } else if (this.state.sort_header == "sbalanced") {
      if (this.state.sort_htl == "high") {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseInt(b.Balance) +
              parseInt(b.Charges_os) -
              (parseInt(a.Balance) + parseInt(a.Charges_os))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      } else {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseInt(a.Balance) +
              parseInt(a.Charges_os) -
              (parseInt(b.Balance) + parseInt(b.Charges_os))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      }
    } else {
      if (this.state.sort_htl == "high") {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseInt(b.Collected) +
              parseInt(b.Other_charges_rcvd) -
              (parseInt(a.Collected) + parseInt(a.Other_charges_rcvd))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      } else {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseInt(a.Collected) +
              parseInt(a.Other_charges_rcvd) -
              (parseInt(b.Collected) + parseInt(b.Other_charges_rcvd))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      }
    }

    console.log(this.sortModal);
    */
  }

  handlesortdbc(event) {
    // ✅ NEW: Store radio button value and log it
    this.setState({ sort_header: event.target.value });

    console.log('🔘 Sort by selected:', event.target.value);
  }

  // logout() {
  //   localStorage.clear();
  //   this.props.history.push("/");
  // }

  handlesorthtl(event) {
    // ✅ NEW: Store sort order (high/low) and log it
    this.setState({ sort_htl: event.target.value });

    console.log('🔼 Sort order selected:', event.target.value);

    /* ❌ OLD CLIENT-SIDE SORTING (DEPRECATED - kept for reference)
    if (this.state.sort_htl == "high") {
        if (this.state.sort_header == "sdemand") {
            this.state.sort_data = [].concat(this.state.cnames)
                .sort((a, b) => b.Demand - a.Demand);

            this.state.cnames = this.state.sort_data;
        } else if (this.state.sort_header == "sbalanced") {
            this.state.sort_data = [].concat(this.state.cnames)
                .sort((a, b) => b.Balance - a.Balance);

            this.state.cnames = this.state.sort_data;
        } else if (this.state.sort_header == "scollected") {
            this.state.sort_data = [].concat(this.state.cnames)
                .sort((a, b) => b.Collected - a.Collected);

            this.state.cnames = this.state.sort_data;
        }
        this.forceUpdate();
    } else {
        if (this.state.sort_header == "sdemand") {
            this.state.sort_data = [].concat(this.state.cnames)
                .sort((a, b) => a.Demand - b.Demand);
            this.state.cnames = this.state.sort_data;
        } else if (this.state.sort_header == "sbalanced") {
            this.state.sort_data = [].concat(this.state.cnames)
                .sort((a, b) => a.Balance - b.Balance);
            this.state.cnames = this.state.sort_data;
        } else if (this.state.sort_header == "scollected") {
            this.state.sort_data = [].concat(this.state.cnames)
                .sort((a, b) => a.Collected - b.Collected);
            this.state.cnames = this.state.sort_data;
        }
        this.forceUpdate();
    }

    // console.log(this.state.sort_data);
    */
  }

  handleCall = (household_id) => {
    const uid = localStorage.getItem("in_userid");
    // if (!uid) {
    //   this.setState({ isLogout: true, isSpin: false });
    //   return;
    //   // localStorage.clear();
    //   // this.props.history.push("/");
    // }
    /*Check if data is null then logout*/
    var arr = [uid, household_id];
    var chkdata = chkapiinput(arr);
    if (chkdata === false) {
      this.setState({ isSpin: false });
      setTimeout(function() {
        logout();
      }, 2000);
    }
    const formdata = new FormData();
    formdata.append("in_userid", uid);
    formdata.append("household_id", household_id);

    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    let generate_Id = generateId(10);
    customFetch(process.env.REACT_APP_URL + "/save/cso/call/details", {
      method: "POST",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
      body: formdata,
    })
      .then(() => {
        this.fetchDetails();
      })
      .catch((error) => {console.log("error", error);this.setState({isSpin: false});});
    this.forceUpdate();
  };
  chkTotalamt = (e) => {
    this.setState({
      total_amt: e.target.value.replace(/\D/, ""),
    });
    if (e.target.value.replace(/\D/, "")<=(parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os)) && e.target.value!=="" && this.state.cash_remark!="") {
      this.setState({ isDisablecollection: false });
    } else {
      this.setState({ isDisablecollection: true });
    }
  };
  chkTotal = (e) => {
    console.log("amount:", e.target.value);
    var pattern = new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/g);
    if (e.target.name == "totpay") {
      this.setState({ totpay: e.target.value.replace(/[^\d.-]/g, "") });
      //var pattern = new RegExp(/^(?!0\.00)\d{1,3}(\d{3})*(\.\d\d)?$/gm);
      if (!pattern.test(e.target.value.replace(/[^\d.-]/g, "")) && e.target.value.replace(/[^\d.-]/g, "")=="") {
        this.setState({
          smsamountErr: "Please Enter Valid Amount",
          issmsamount: true,
          isDisablecollection: true,
        });
      } else if(parseInt(e.target.value.replace(/[^\d.-]/g, ""))>(parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os))) {
        this.setState({
          // smsamountErr: "Please Enter Valid Amount",
          // issmsamount: true,
          isDisablecollection: true,
        });
      } else if (parseInt(e.target.value.replace(/[^\d.-]/g, "")) > 99999) {
        this.setState({
          issmsamount: true,
          isDisablecollection: true,
          smsamountErr:
            "आप इस हाउसहोल्ड के लिए 99999" +
            ' से अधिक कलेक्शन नहीं कर सकते। ज्यादा जानकारी के लिए WhatsApp में <a href="https://chat.whatsapp.com/K1kzdBQHwhoLk3u8LtxApZ"> AceN Assist Group </a> में मैसेज करिये। ',
        });
      } else if (e.target.value == 0) {
        this.setState({
          issmsamount: true,
          isDisablecollection: true,
          smsamountErr: "Amount can not be 0 (zero)",
        });
      } else {
        this.setState({
          issmsamount: false,
          smsamountErr: "",
          isDisablecollection: false,
        });
      }
    }

    if(e.target.name === "cash_remark") {
      if(e.target.value == "") {
        this.setState({isDisablecollection:true});
      } else if(e.target.value != "" && this.state.total_amt<=(parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os)) && this.state.total_amt!="") {
        this.setState({isDisablecollection:false});
      }
    }

    if(e.target.name == "cheque_number" || e.target.name == "issuer_name" || e.target.name == "issuer_remark" || e.target.name == "cheque_date") {
      if(this.state.cheque_date=="" || this.state.cheque_date==undefined) {
        this.setState({isDisablecollection:true});
      }
      if(this.state.issuer_name=="" || this.state.issuer_name==undefined) {
        this.setState({isDisablecollection:true});
      }
      if(this.state.cheque_number.length!=6) {
        this.setState({isDisablecollection:true});
      }
      if(this.state.issuer_remark=="" || this.state.issuer_remark==undefined) {
        this.setState({isDisablecollection:true});
      }
      // alert(this.state.cheque_date)
      if(this.state.cheque_date!="Invalid date" && this.state.cheque_date!="" && this.state.cheque_amount!="" && this.state.cheque_amount<(parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os)) && this.state.issuer_name!="" && this.state.cheque_number.length === 6 && this.state.issuer_remark!="" ){
        this.setState({isDisablecollection:false});
      }
    }

    if (e.target.name == "cheque_amount") {
      this.setState({ cheque_amount: e.target.value.replace(/[^\d.-]/g, "") });
      //var pattern = new RegExp(/^(?!0\.00)\d{1,3}(\d{3})*(\.\d\d)?$/gm);

      if (e.target.value.replace(/[^\d.-]/g, "")<=(parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os))) {
        this.setState({
          chequeamountErr: "",
        });
      }
      if (!pattern.test(e.target.value.replace(/[^\d.-]/g, ""))) {
        this.setState({
          chequeamountErr: " Please Enter Valid Amount",
          ischequeamount: true,
          isDisablecollection: true,
        });
      } else if(parseInt(e.target.value.replace(/[^\d.-]/g, ""))>(parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os))) {
        this.setState({
          chequeamountErr: ` You cannot collect more than ${parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os)}`,
          // ischequeamount: true,
          isDisablecollection: true,
        });
      } else if(e.target.value.replace(/[^\d.-]/g, "")<=(parseFloat(this.state.Loan_os)+parseFloat(this.state.Charges_os)) && e.target.value.replace(/[^\d.-]/g, "") != "" && this.state.cheque_date!="" && this.state.issuer_name!="" && this.state.cheque_number.length === 6 && this.state.issuer_remark!=""){
        let errorMsg = {};
        errorMsg["issuer_remark"] ="";
        errorMsg["issuer_name"] ="";
        errorMsg["cheque_number"] ="";
        errorMsg["cheque_date"] ="";
        errorMsg["cheque_upload"] ="";
        this.setState({
          chequeamountErr: "",
          isDisablecollection:false,
          errorMsg: errorMsg,
        });
      }
    }
  };
  chksmsmob = (e) => {
    console.log("chkmob:", e.target.value);
    this.setState({ smsmobile: e.target.value.replace(/\D/g, "") });
    if (e.target.value.replace(/\D/g, "").length != 10) {
      //isValid = false;
      this.setState({
        smsmobileErr: "Please Enter Valid Mobile Number",
        isDisablecollection: true,
      });
      //errors["Mobilenumber"] = "Please enter valid  Mobile Number.";
    } else {
      this.setState({ smsmobileErr: "", isDisablecollection: false });
    }
  };
  handleSubmit = () => {
    //event.preventDefault();
    if (navigator.onLine) {
      this.setState({ isDisable: true, isDisableBtn: true, isSpin: true });
      const uid = localStorage.getItem("in_userid");
      if (!uid) {
        this.setState({ isLogout: true, isSpin: false, isOpen: false });
        return;
        // localStorage.clear();
        // this.props.history.push("/");
      }
      const { api_token, hh_id, Borrower_Name, household_id } =
        (this.props.location && this.props.location.state) || {};
      if (uid) {
        /*Check if data is null then logout*/
        // var arr = [
        //   hh_id,
        //   this.state.isBalanceZero
        //     ? parseFloat(this.state.Loan_os)
        //     : this.state.totalAmt,
        //   this.state.isBalanceZero ? this.state.Charges_os : this.state.charges,
        //   this.state.payment_method,
        //   uid,
        // ];
        // console.log("arr", arr);
        // var chkdata = chkapiinput(arr);
        // if (chkdata === false) {
        //   this.setState({ isSpin: false });
        //   setTimeout(function () {
        //     logout();
        //   }, 2000);
        // }
        const formdata = new FormData();
        formdata.append("in_household_id", this.state.household_id);
        formdata.append(
          "in_amount_collected",
          // this.state.isBalanceZero
          //   ? parseFloat(this.state.Loan_os)
          //   : this.state.totalAmt
          this.state.total_amt
        );
        formdata.append("in_charges_collected", this.state.Charges_os);
        formdata.append("in_collection_mode_flag", "C (Cash)"); //this.state.payment_method
        // in_reference_number,in_remark,in_frontend_file_name use for upi or comes from ocr read for UPI
        formdata.append("in_reference_number", "");
        // if (this.state.OcrTransaction_ID) {
        //   formdata.append(
        //     "in_remark",
        //     this.state.remark + "_" + this.state.OcrTransaction_ID
        //   );
        // } else {
        //   formdata.append("in_remark", this.state.remark);
        // }
        formdata.append("in_remark", this.state.cash_remark);
        formdata.append("in_frontend_file_name", "");
        formdata.append("in_userid", uid);
        formdata.append("in_collection_type", "P");
        formdata.append("csf", this.state.serverflag);
        formdata.append("product_id", process.env.REACT_APP_PRODUCTID);
        let generate_Id = generateId(10);
        const requestOptions = {
          method: "POST",
          headers: {
            "api-token": api_token,
            component_id: generate_Id1,
            apiId: generate_Id,
            api_group_id: "",
            component: this.constructor.name,
            user_id: localStorage.getItem("in_userid"),
          },
          body: formdata,
        };

        // for (const value of formdata.values()) {
        //   console.log(value);
        // }
        let base_url = process.env.REACT_APP_URL;
        if(this.state.serverflag=="RF"){
          base_url = process.env.REACT_APP_R_URL;
        }
        customFetch(
          base_url + "/set/collection/household/customer",
          requestOptions
        )
          .then((response) => {
            if (response.headers.get("api_code") > 0) {
              this.setState({
                isErrOpen: true,
                api_error_message: response.headers.get("api_error_message"),
                isSpin: false,
                isOpen: false,
              });
            }
            return response.json();
          })
          .then((data) => {
            console.log(data);
            if (
              data.api_code === 4 ||
              data.api_code === 3 ||
              data.api_code === 5
            ) {
              localStorage.clear();
              this.props.history.push("/");
            }
            if (data.txn_ref_no) {
              this.props.history.push({
                pathname: "/collectionSuccess",
                state: {
                  api_token: api_token,
                  tmp_in_amount_collected: this.state.total_amt, //data.tmp_in_amount_collected,
                  tmp_in_charges_collected: data.tmp_in_charges_collected,
                  tmp_timestamp: data.tmp_timestamp,
                  tmp_txn_ref_no: data.txn_ref_no,
                  payment_method: this.state.payment_method,
                  Household_name: this.state.Lead_Name,
                  OcrAmount: this.state.OcrAmount,
                  OcrBank: this.state.OcrBank,
                  OcrDate: this.state.OcrDate,
                  OcrFrom: this.state.OcrFrom,
                  OcrTo: this.state.OcrTo,
                  OcrTransaction_ID: this.state.OcrTransaction_ID,
                  OcrUPI_UTR_Ref: this.state.refno,
                  Ocrvendor: this.state.Ocrvendor,
                  message: data.message,
                },
              });
            } else {
              this.setState({
                isErrOpen: true,
                api_error_message: data.message,
                isSpin: false,
                isOpen: false,
                isDisable: false,
              });
            }
          })
          .catch((error) => {console.log("error", error);this.setState({isSpin: false});});
      } else {
        this.setState({
          isErrOpen: true,
          api_error_message: "Please Contact Helpdesk",
          isSpin: false,
        });
      }
    } else {
      this.setState({
        isOffline: true,
        isOpen: false,
        isSpin: false,
      });
    }
  };
  chequeOCR(e) {
    e.preventDefault();
    console.log("file", e.target.files[0]);
    this.setState({
      fileupload: e.target.files[0],
      isSpin: true, // Show loading spinner during OCR processing
    });

    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    const formdata = new FormData();
    formdata.append("file", e.target.files[0]);
    let generate_Id = generateId(10);
    customFetch(process.env.REACT_APP_URL + "/get/cheque/details", {
      method: "POST",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
      body: formdata,
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
          return;
        }
        return res.json();
      })
      .then((data) => {
        console.log("Cheque:", data.data[0].chq_date);
          this.setState({
          cheque_amount: data.data[0].chq_amount,
            cheque_date: data.data[0].chq_date
              ? moment(data.data[0].chq_date, "DD-MM-YYYY").format("YYYY-MM-DD")
              : "",
          cheque_number: data.data[0].chq_no,
          issuer_name: data.data[0].name_of_issuer,
        });
      })
      .catch((error) => {console.log("error", error);this.setState({isSpin: false});});
  }
  
  handleCallButtonClick = (householdId, household_number, primaryMobile) => {
    this.props.history.push({
      pathname: '/AlternateNumber',
      state: {
        api_token: localStorage.getItem("api_token"),
        householdId,
        household_number,
        primaryMobile,
      }
    });
  }

  render() {
    const { api_token, effective_designation_id } =
      (this.props.location && this.props.location.state) || {};
    const uid = localStorage.getItem("in_userid");
    const { currentPage, pageSize } = this.state;
    // console.log(
    //   "chq_amount",
    //   this.state.chequeOCRdata && this.state.chequeOCRdata.chq_amount
    // );

    let data = this.state.items;
    const {
      isErrOpen,
      api_error_message,
      isHHReg,
      issendQR,
      isSmssent,
      smsSentmsg,
      errorMsg,
      isOpen,
    } = this.state;

    // if (temp.length > 0) {
    //   console.log(data.Branches);

    // }

    // let cnames = this.state.cnames;

    // let cnames = this.state.cnames;

    if (this.state.cnames.length > 0) {
      this.state.cnames.map((item) => {
        var findItem = this.state.uniqueNames.find(
          (x) => x.indexOf(item.Lead_Name.split(" ")[0]) == 0
        );
        if (!findItem)
          this.state.uniqueNames.push(item.Lead_Name.split(" ")[0]);
      });

      this.state.uniqueNames = this.state.uniqueNames.sort((a, b) =>
        a.localeCompare(b)
      );
    }
    console.log("this.state.cnames", this.state.cnames);
    const paginatedData = this.state.cnames && this.state.cnames.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    return (
      <>
        {/* No main loader - let each API manage its own loading state */}
        <div
          className={
            isOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content pt-confirm-box col-sm-12">
              <span className="cb-cname">Household Name</span>

              <div className="cb-cname-box">{this.state.Lead_Name}</div>
              <span className="cb-cname">Household ID</span>

              <div className="cb-cname-box">{this.state.HH_ID}</div>
              <div className="emiCharge">
                <div>
                  <span className="cb-cname">Total Amount</span>
                  <div className="cb-cname-box">
                    {"Rs. " + this.state.total_amt}

                    {/* Rs. {parseFloat(this.state.totsum)} */}
                  </div>
                  <div>
                    <label className="cb-cname">Current Dues:</label>
                    <div>
                      <span className="emi-left">
                        [ Amount{" "}
                        <img src={require("../assets/images/rupee.png")} />{" "}
                        {parseInt(this.state.Balance).toLocaleString("en-IN")}
                        {/* {parseFloat(this.state.totalAmt)} */}
                      </span>
                      <span className="emi-right">
                        {" "}
                        Charges{" "}
                        <img src={require("../assets/images/rupee.png")} />{" "}
                        {parseInt(this.state.Charges_os).toLocaleString(
                          "en-IN"
                        )}
                        {/* {parseFloat(this.state.charges)} */}]
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cb-buttons">
                <div className="col-sm-6">
                  <button
                    className="btn btn-primary btn-lg btn-block rbtn"
                    onClick={() => {
                      this.handleSubmit();
                    }}
                    //disabled={isDisableBtn}
                  >
                    Confirm
                  </button>
                </div>
                <div className="col-sm-6">
                  <button
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.setState({ isOpen: false })}
                    className="btn btn-primary btn-lg btn-block rbtn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            this.state.isOpenCollect
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <CollectionModal
            items={this.state.details && this.state.details}
            isOpen={this.state.isOpenCollect}
            api_token={api_token}
            onClose={() => this.setState({ 
              isOpenCollect: false,
              // payment_method: "",
              // total_amt: "",
              // Lead_Name: "",
              // HH_ID: "",
              // household_id: "",
              // Charges_os: "",
              // previous_transactions: [],
              // Balance: "",
              // serverflag: "",
              // Loan_os: "",
              details: null,
              fliped: false
            })}
            onDataRefresh={this.handleDataRefresh}
          />
        </div>
        <div
          className={
            isErrOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  this.setState({ isErrOpen: false });
                  {
                    this.state.isReload && this.fetchDetails();
                  }
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>{api_error_message}</p>
              {this.state.cheque_txn_ref_no && (
                <p>Ref. Number : {this.state.cheque_txn_ref_no}</p>
              )}
            </div>
          </div>
        </div>
        <div
          className={
            this.state.isLogout
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => logout(null, null, true)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>We Have to Log You Out. Kindly Login again</p>
            </div>
          </div>
        </div>
        <div
          className={
            isSmssent
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isSmssent: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p
                dangerouslySetInnerHTML={{
                  __html: smsSentmsg,
                }}
              />
            </div>
          </div>
        </div>
        <div
          className={
            isHHReg
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isHHReg: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>Do you want to register the household for NACH?</p>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/Nach_type",
                      state: {
                        api_token: api_token,
                        household_id: this.state.household_id,
                      },
                    });
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => this.setState({ isHHReg: false })}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <div
          className={
            issendQR
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ issendQR: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p className="PayLinkLabel">
                Do you want to send Payment link to customer?
              </p>
              <div>
                <div className="row mb-2">
                  <div className="col-6">
                    <label className="PayLinkLabel">Phone No.</label>
                    <input
                      className="form-control"
                      name="smsmobile"
                      value={this.state.smsmobile}
                      readOnly={this.state.smsread}
                      onChange={this.chksmsmob}
                    />
                    <img
                      src={require("../assets/images/edit.png")}
                      className="smsmobedt"
                      onClick={(e) => this.setState({ smsread: false })}
                    />
                  </div>
                  <div className="col-6">
                    <label className="PayLinkLabel">Amount</label>
                    <input
                      className="form-control"
                      name="totpay"
                      readOnly={this.state.amountread}
                      value={this.state.totpay}
                      onChange={this.chkTotal}
                    />
                    <img
                      src={require("../assets/images/edit.png")}
                      className="smsmobedt"
                      onClick={(e) => this.setState({ amountread: false })}
                    />
                  </div>
                  <div className="col-md-12 errmsg">
                    {this.state.smsmobileErr}
                  </div>

                  <div className="col-md-12 errmsg">
                    {this.state.smsamountErr ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.smsamountErr,
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={this.state.issmsmobile || this.state.issmsamount}
                  onClick={() => {
                    this.qrsms();
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => this.setState({ issendQR: false })}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div> */}
        <div
          className="modal fade bd-example-modal-sm"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="sort-filter"
          ref={this.sortModal}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content sort_block col-sm-12">
              <span className="bluetext-header-sort">SORT BY</span>
              <table className="table">
                {/* <thead>
                                    <tr>
                                        <th colSpan="2"></th>
                                    </tr>
                                </thead> */}
                <tbody>
                  <tr>
                    <td>Demand</td>
                    <td>
                      <input
                        type="radio"
                        className="form-check-input"
                        value="sdemand"
                        name="sortmenu"
                        onChange={this.handlesortdbc}
                        checked={this.state.sort_header === "sdemand"}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Balance</td>
                    <td>
                      <input
                        type="radio"
                        className="form-check-input"
                        value="sbalanced"
                        name="sortmenu"
                        onChange={this.handlesortdbc}
                        checked={this.state.sort_header === "sbalanced"}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Collected</td>
                    <td>
                      <input
                        type="radio"
                        className="form-check-input"
                        value="scollected"
                        name="sortmenu"
                        onChange={this.handlesortdbc}
                        checked={this.state.sort_header === "scollected"}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="sortBlueBox">
                <div>
                  <input
                    type="radio"
                    id="htl"
                    name="htl"
                    value="high"
                    onChange={this.handlesorthtl}
                    checked={this.state.sort_htl === "high"}
                  />
                  <label htmlFor="high">&nbsp;High To Low</label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="htl"
                    name="htl"
                    onChange={this.handlesorthtl}
                    value="low"
                    checked={this.state.sort_htl === "low"}
                  />
                  <label htmlFor="low">&nbsp;Low To High</label>
                </div>
              </div>
              <button
                data-dismiss="modal"
                type="button"
                className="btn btn-primary btn-lg btn-block rbtn search_elements"
                onClick={this.handlesort}
              >
                Apply
              </button>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="filter"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="filter_window">
                <div className="filter_header">
                  <table className="table filter-table">
                    <thead>
                      <tr>
                        <th>Filter</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="nameFilter"
                        className="unique-name-click"
                      >
                        <td>Name</td>
                      </tr>

                      <tr
                        onClick={this.handleFilterMenu}
                        id="locationFilter"
                        className="unique-name-click"
                      >
                        <td>Location</td>
                      </tr>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="demandFilter"
                        className="unique-name-click"
                      >
                        <td>Demand</td>
                      </tr>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="balFilter"
                        className="unique-name-click"
                      >
                        <td>Balance</td>
                      </tr>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="colFilter"
                        className="unique-name-click"
                      >
                        <td>Collection</td>
                      </tr>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="rfandnonrf"
                        className="unique-name-click"
                      >
                        <td>RF / Non RF</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="filter_amt" id="filter-sub-menu">
                  {this.state.isShowName && (
                    <div className="unique-names" id="uniqueNameDiv">
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        {this.state.uniqueNames.map((item, key) => (
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <input
                                  type="checkbox"
                                  id={item}
                                  name={item}
                                  onChange={this.addName}
                                />
                                <label htmlFor="vehicle1"> &nbsp; {item}</label>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>
                  )}

                  {this.state.isShowLoc && (
                    <div className="unique-names">
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>

                      <table className="table table-borderless">
                        {this.state.uniqueLocation.length > 0 ? (
                          this.state.uniqueLocation.map((item, key) => (
                            <tbody>
                              <tr>
                                <td>
                                  {" "}
                                  <input
                                    type="checkbox"
                                    id={item}
                                    name={item}
                                    onChange={this.addName}
                                  />
                                  <label htmlFor="vehicle1">
                                    {" "}
                                    &nbsp; {item}
                                  </label>
                                </td>
                              </tr>
                            </tbody>
                          ))
                        ) : (
                          <tbody>
                            <tr>
                              <td>No Location</td>
                            </tr>
                          </tbody>
                        )}
                      </table>
                    </div>
                  )}
                  {this.state.isShowDem && (
                    <>
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilterl0"
                                name="dFilterl0"
                                onChange={this.addName}
                                defaultChecked={this.state.a0}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Less Than 0
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter0"
                                name="dFilter0"
                                onChange={this.addName}
                                defaultChecked={this.state.a1}
                              />
                              <label htmlFor="vehicle1"> &nbsp; Rs. 0 </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter1"
                                name="dFilter1"
                                onChange={this.addName}
                                defaultChecked={this.state.a2}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Rs. 1 - Rs. 2000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter2"
                                name="dFilter2"
                                onChange={this.addName}
                                defaultChecked={this.state.a3}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp;Rs. 2001 - Rs. 3999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter3"
                                name="dfilter3"
                                onChange={this.addName}
                                defaultChecked={this.state.a4}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 4000 - Rs. 6999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter4"
                                name="dFilter4"
                                onChange={this.addName}
                                defaultChecked={this.state.a5}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 7000 - Rs. 9000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter5"
                                name="dFilter5"
                                onChange={this.addName}
                                defaultChecked={this.state.a6}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 9001 - Above
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}

                  {this.state.isShowBal && (
                    <>
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilterl0"
                                name="bFilterl0"
                                onChange={this.addName}
                                defaultChecked={this.state.b0}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Less Than 0
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter0"
                                name="bFilter0"
                                onChange={this.addName}
                                defaultChecked={this.state.b1}
                              />
                              <label htmlFor="vehicle1"> &nbsp; Rs. 0 </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter1"
                                name="bFilter1"
                                onChange={this.addName}
                                defaultChecked={this.state.b2}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Rs. 1 - Rs. 2000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter2"
                                name="bFilter2"
                                onChange={this.addName}
                                defaultChecked={this.state.b3}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp;Rs. 2001 - Rs. 3999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter3"
                                name="bFilter3"
                                onChange={this.addName}
                                defaultChecked={this.state.b4}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 4000 - Rs. 6999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter4"
                                name="bFilter4"
                                onChange={this.addName}
                                defaultChecked={this.state.b5}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 7000 - Rs. 9000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter5"
                                name="bFilter5"
                                onChange={this.addName}
                                defaultChecked={this.state.b6}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 9001 - Above
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}

                  {this.state.isShowCol && (
                    <>
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilterl0"
                                name="cFilterl0"
                                onChange={this.addName}
                                defaultChecked={this.state.c0}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Less Than 0
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter0"
                                name="cFilter0"
                                onChange={this.addName}
                                defaultChecked={this.state.c1}
                              />
                              <label htmlFor="vehicle1"> &nbsp; Rs. 0 </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter1"
                                name="cFilter1"
                                onChange={this.addName}
                                defaultChecked={this.state.c2}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Rs. 1 - Rs. 2000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter2"
                                name="cFilter2"
                                onChange={this.addName}
                                defaultChecked={this.state.c3}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp;Rs. 2001 - Rs. 3999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter3"
                                name="cFilter3"
                                onChange={this.addName}
                                defaultChecked={this.state.c4}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 4000 - Rs. 6999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter4"
                                name="cFilter4"
                                onChange={this.addName}
                                defaultChecked={this.state.c5}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 7000 - Rs. 9000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter5"
                                name="cFilter5"
                                onChange={this.addName}
                                defaultChecked={this.state.c6}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 9001 - Above
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                  {
                    this.state.isRFnonRF && (
                      <>
                        <table className="table table-borderless">
                          <tbody>                            
                            <tr>
                              <td>
                                {" "}
                                <input
                                  type="checkbox"
                                  id="RF"
                                  name="RF"
                                  onChange={this.addName}
                                  defaultChecked={this.state.r1}
                                />
                                <label htmlFor="vehicle1"> &nbsp; RF </label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {" "}
                                <input
                                  type="checkbox"
                                  id="M"
                                  name="M"
                                  onChange={this.addName}
                                  defaultChecked={this.state.r2}
                                />
                                <label htmlFor="vehicle1">
                                  {" "}
                                  &nbsp; Non RF
                                </label>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    )
                  }
                  <div className="filter-btn-div">
                    <button
                      data-dismiss="modal"
                      className="btn btn-primary btn-block btn-lg rbtn"
                      onClick={this.filter}
                    >
                      APPLY
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade bd-example-modal-sm"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="search"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content search_block col-sm-12">
              {/* <form onSubmit={this.searchCustomer}> */}

              <input
                type="text"
                className="form-control rinput1 search_elements1"
                id="sfname"
                name="sfname"
                placeholder="Enter First Name or Location or Household ID"
                required
                onChange={this.handleSearchText}
              />
              <button
                data-dismiss="modal"
                onClick={this.searchCustomer}
                type="submit"
                className="btn btn-primary btn-lg btn-block rbtn search_elements"
              >
                Search
              </button>
              {/* </form> */}
            </div>
          </div>
        </div>

        <div className="container">
          <div className="top_nav">
            <a>
              <div
                className="icon_bg"
                onClick={() => this.props.history.goBack()}
              >
                <img
                  src={require("../assets/images/back.png")}
                  className="icon_img"
                />
              </div>
            </a>
            <span className="head-title">Search Household</span>

            <a>
              {this.state.flag === 0 && (
                <div className="log-out-deposit">
                  <img
                    src={require("../assets/images/power-off.png")}
                    onClick={() => logout(null, null, true)}
                    alt=""
                  />
                </div>
              )}
            </a>
          </div>
          {this.state.time_flag == 1 ? (
            <div className="maintaenance-container">
              <div className="maintaenance-image">
                <img src="data:image/gif;base64,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" />
              </div>
              <br />
              <div class="content">
                <h3>
                  <span className="maintaenance-text">
                    {" "}
                    Maintenance in progress.
                    <br />
                    <p>{this.state.maintaenance}</p>
                  </span>
                </h3>
                <p>Please stand by</p>
              </div>
            </div>
          ) : (
            <>
              <PEDiv
                element_id="filter_button_container"
                className="filter_button_container"
              >
                <PEDiv
                  element_id="Search_HH_Sort_Filter"
                  data-toggle="modal"
                  data-target="#sort-filter"
                >
                  <div className="icon_bg">
                    <img
                      element_id="Search_HH_Sort_Filter_Img"
                      src={require("../assets/images/list.png")}
                      className="icon_img"
                    />
                  </div>
                </PEDiv>
                {/* FILTER BUTTON - COMMENTED OUT */}
                {/* <PEDiv
                  element_id="Search_HH_Filter"
                  data-toggle="modal"
                  data-target="#filter"
                >
                  <div className="icon_bg">
                    <img
                      element_id="Search_HH_Filter_Img"
                      src={require("../assets/images/sort.png")}
                      className="icon_img"
                    />
                  </div>
                </PEDiv> */}
                {/* SEARCH INPUT - MOVED FROM MODAL TO TOP BAR */}
                <div style={{ 
                  flex: 1, 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  background: '#fff',
                  borderRadius: '25px',
                  padding: '8px 15px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                  <input
                    type="text"
                    name="household_search"
                    autoComplete="on"
                    style={{
                      flex: 1,
                      border: 'none',
                      outline: 'none',
                      fontSize: '14px',
                      padding: '4px 0',
                      color: '#333',
                      backgroundColor: 'transparent',
                      caretColor: '#333'
                    }}
                    placeholder="Search by Household Number"
                    value={this.state.search_text}
                    onChange={(e) => this.setState({ search_text: e.target.value })}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        this.searchCustomer();
                      }
                    }}
                  />
                  <div 
                    onClick={this.searchCustomer}
                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  >
                    <PEImg
                      element_id="Search_HH_Search_Img"
                      src={require("../assets/images/search.png")}
                      style={{ width: '20px', height: '20px' }}
                    />
                  </div>
                </div>
                {/* SEARCH MODAL BUTTON - COMMENTED OUT */}
                {/* <PEDiv
                  element_id="Search_HH_Search"
                  data-toggle="modal"
                  data-target="#search"
                >
                  <div className="icon_bg">
                    <img
                      element_id="Search_HH_Search_Img"
                      src={require("../assets/images/search.png")}
                      className="icon_img"
                    />
                  </div>
                </PEDiv> */}
                {/* CALL BUTTON - COMMENTED OUT */}
                {/* <PEDiv
                  element_id="Search_HH_CallBtn"
                  onClick={this.handleCallSort}
                >
                  <div
                    className={
                      this.state.callsort == 0
                        ? "icon_bg relative"
                        : "icon_bg_call relative"
                    }
                  >
                    <span
                      className="icon_notification"
                      hidden={this.state.notCalledCount == 0}
                    >
                      {this.state.notCalledCount}
                    </span>
                    <img
                      element_id="Search_HH_CallBtn_Img"
                      src={require("../assets/images/telephone.png")}
                      className="icon_img"
                    />
                  </div>
                </PEDiv> */}
              </PEDiv>
              {this.state.maintaenanceBanner ? (
                <>
                  <marquee class="maintaenance-text marquee_data">
                    {this.state.maintaenanceBannerText}
                  </marquee>
                  <div class="maintaenance-text text-center timer_data">
                    {this.state.banner_timer}
                  </div>
                </>
              ) : (
                ""
              )}
              <div
                element_id="Search_HH_Day_Filter"
                className="filter_button_container_sh"
              >
                <div element_id="Search_HH_Fortheday" class="form-check">
                  <input
                    element_id="Search_HH_Fortheday_Input"
                    class="form-check-input"
                    type="radio"
                    name="select-day-month"
                    value="day"
                    checked={this.state.isDay}
                    onClick={this.checkDates}
                    onChange={this.getData}
                  />
                  <label class="form-check-label" for="flexRadioDefault1">
                    <b>For The Day</b>
                  </label>
                </div>
                <div
                  element_id="Search_HH_Monthtilldate"
                  class="form-check"
                >
                  <input
                    element_id="Search_HH_Monthtilldate_Input"
                    class="form-check-input"
                    type="radio"
                    name="select-day-month"
                    value="date"
                    checked={this.state.isDate}
                    onClick={this.checkDates}
                    onChange={this.getData}
                  />
                  <label class="form-check-label" for="flexRadioDefault2">
                    <b>Month Till Date</b>
                  </label>
                </div>
                <div element_id="Search_HH_Forthemonth" class="form-check">
                  <input
                    element_id="Search_HH_Forthemonth_Input"
                    class="form-check-input"
                    type="radio"
                    name="select-day-month"
                    value="month"
                    checked={this.state.isMonth}
                    onClick={this.checkDates}
                    onChange={this.getData}
                  />
                  <label class="form-check-label" for="flexRadioDefault2">
                    <b>For The Month</b>
                  </label>
                </div>
              </div>

              <div className="title-holder">
                <h2></h2>
              </div>              
              {/* {
              // effective_designation_id !=
              // process.env.REACT_APP_EFFECTIVE_DESIGNATION_ID_CSO
              !localStorage.getItem("hh_mapped_collection_users").split(",").includes(
                effective_designation_id.toString()
              ) ? (
                <PEDiv
                element_id="Search_HH_hhnumber_holder"
                  className="hhnumber-holder mb-4"
                >
                  <div className="row">
                    <div className="col-10">
                      <input
                        element_id="Search_HH_hhnumber_input"
                        className="form-control"
                        name="hhnumber"
                        value={this.state.hhnumber}
                        onChange={(e) =>
                          this.setState({ hhnumber: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-2">
                      <button
                        element_id="Search_HH_hhnumber_search_btn"
                        className="btn btn-primary"
                        disabled={!this.state.hhnumber}
                        onClick={() => this.fetchDetails()}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )} */}

              {/* Collection Details Section - with skeleton loader - ALWAYS SHOW */}
              {this.state.isSummaryLoading ? (
                <PEDiv
                  element_id="Search_HH_CollectionDetail_Skeleton"
                  className="filter_button_container_sh"
                  style={{ display: 'flex', gap: '15px', justifyContent: 'space-around' }}
                >
                  {/* Skeleton for Fully Collected */}
                  <div style={{ flex: 1, padding: '10px' }}>
                    <div style={{ 
                      height: '20px', 
                      backgroundColor: '#e0e0e0', 
                      borderRadius: '4px',
                      marginBottom: '5px',
                      animation: 'skeleton-loading 1s infinite'
                    }}></div>
                  </div>
                  {/* Skeleton for Partial Collected */}
                  <div style={{ flex: 1, padding: '10px' }}>
                    <div style={{ 
                      height: '20px', 
                      backgroundColor: '#e0e0e0', 
                      borderRadius: '4px',
                      marginBottom: '5px',
                      animation: 'skeleton-loading 1s infinite'
                    }}></div>
                  </div>
                  {/* Skeleton for No Collection */}
                  <div style={{ flex: 1, padding: '10px' }}>
                    <div style={{ 
                      height: '20px', 
                      backgroundColor: '#e0e0e0', 
                      borderRadius: '4px',
                      marginBottom: '5px',
                      animation: 'skeleton-loading 1s infinite'
                    }}></div>
                  </div>
                  <style>{`
                    @keyframes skeleton-loading {
                      0%, 100% { opacity: 0.6; }
                      50% { opacity: 1; }
                    }
                  `}</style>
                </PEDiv>
              ) : (
                <PEDiv
                  element_id="Search_HH_CollectionDetail"
                  className="filter_button_container_sh"
                >
                  <PESpan
                    element_id="Search_HH_FullyCollected"
                    className="greentext"
                  >
                    Fully Collected: <strong>{this.state.Full_pay}</strong>
                  </PESpan>
                  <PESpan
                    element_id="Search_HH_PartialCollected"
                    className="redtext"
                  >
                    Partial Collected: <strong>{this.state.Part_pay}</strong>
                  </PESpan>
                  <PESpan
                    element_id="Search_HH_NoCollected"
                    className="redtext"
                  >
                    No Collection: <strong>{this.state.No_pay}</strong>
                  </PESpan>
                </PEDiv>
              )}

              {/* Amount Blocks Section - with skeleton loader - ALWAYS SHOW */}
              <PEDiv
                element_id="Search_HH_Total_amt_Block"
                className="tot_amt_block"
              >
                    {this.state.isSummaryLoading ? (
                      <>
                        {/* Skeleton for Demand */}
                        <PEDiv element_id="Search_HH_Demand_Skeleton" className="amt_b">
                          <div className="blue_block_sh" style={{ 
                            backgroundColor: '#e0e0e0', 
                            borderRadius: '4px',
                            animation: 'skeleton-loading 1s infinite'
                          }}></div>
                          <span className="bluetext" style={{ marginTop: '10px', display: 'block' }}>Demand</span>
                          <style>{`
                            @keyframes skeleton-loading {
                              0%, 100% { opacity: 0.6; }
                              50% { opacity: 1; }
                            }
                          `}</style>
                        </PEDiv>

                        {/* Skeleton for Collected */}
                        <PEDiv element_id="Search_HH_Collected_Skeleton" className="amt_b">
                          <div className="green_block_sh" style={{ 
                            backgroundColor: '#e0e0e0', 
                            borderRadius: '4px',
                            animation: 'skeleton-loading 1s infinite'
                          }}></div>
                          <span className="greentext_sh" style={{ marginTop: '10px', display: 'block' }}>Collected</span>
                          <style>{`
                            @keyframes skeleton-loading {
                              0%, 100% { opacity: 0.6; }
                              50% { opacity: 1; }
                            }
                          `}</style>
                        </PEDiv>

                        {/* Skeleton for Balance */}
                        <PEDiv element_id="Search_HH_Balance_Skeleton" className="amt_b">
                          <div className="red_block_sh" style={{ 
                            backgroundColor: '#e0e0e0', 
                            borderRadius: '4px',
                            animation: 'skeleton-loading 1s infinite'
                          }}></div>
                          <span className="redtext_sh" style={{ marginTop: '10px', display: 'block' }}>Balance</span>
                          <style>{`
                            @keyframes skeleton-loading {
                              0%, 100% { opacity: 0.6; }
                              50% { opacity: 1; }
                            }
                          `}</style>
                        </PEDiv>
                      </>
                    ) : (
                      <>
                        <PEDiv element_id="Search_HH_Demand" className="amt_b">
                          <div className="blue_block_sh">
                            <span className="countLabel">
                              <b>{this.state.D_count}</b>
                            </span>
                            <hr></hr>
                            <span className="d_block_amt">
                              Rs.
                              {!this.state.totalDemand
                                ? "0"
                                : " " +
                                  parseInt(this.state.totalDemand).toLocaleString("en-IN")}
                            </span>
                          </div>
                          <span className="bluetext">Demand</span>
                        </PEDiv>

                        <PEDiv element_id="Search_HH_Collected" className="amt_b">
                          <div className="green_block_sh">
                            <span className="countLabel">
                              <b>{this.state.C_count}</b>
                            </span>
                            <hr></hr>
                            <span className="d_block_amt">
                              Rs.
                              {!this.state.totalCollected
                                ? "0"
                                : " " +
                                  parseInt(this.state.totalCollected).toLocaleString("en-IN")}
                            </span>
                          </div>
                          <span className="greentext_sh">Collected</span>
                        </PEDiv>
                        <PEDiv element_id="Search_HH_Balance" className="amt_b">
                          <div className="red_block_sh">
                            <span className="countLabel">
                              <b>{this.state.B_count}</b>
                            </span>
                            <hr></hr>
                            <span className="d_block_amt">
                              Rs.
                              {!this.state.totalBalance
                                ? "0"
                                : " " +
                                  parseInt(this.state.totalBalance).toLocaleString("en-IN")}
                            </span>
                          </div>
                          <span className="redtext_sh">Balance</span>
                        </PEDiv>
                      </>
                    )}
                </PEDiv>

              {/* Household List - only show when we have data */}
              {this.state.cnames.length > 0 && (
                <>
                  {this.state.isDetailsLoading && (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '40px 20px',
                      gap: '15px'
                    }}>
                      <div style={{
                        width: '30px',
                        height: '30px',
                        border: '3px solid #f3f3f3',
                        borderTop: '3px solid #3498db',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }}></div>
                      <span style={{ color: '#666', fontSize: '14px' }}>Loading more households...</span>
                      <style>{`
                        @keyframes spin {
                          0% { transform: rotate(0deg); }
                          100% { transform: rotate(360deg); }
                        }
                      `}</style>
                    </div>
                  )}

                  <div
                    ref={this.listRef}
                    className="search-hh-list w-100"
                  >
                {this.state.cnames.map((item, key) => {
                let callclass = "bg-success";
                let calldetailclass = "bg-success";
                let ncd = new Date(item.Next_call_dt);
                let calltime = item.call_time;

                if (item.status === "" || item.status === null) {
                  callclass = "bg-danger ring animated";
                  calldetailclass = "bg-danger ring animated";
                } else if (item.status === 0) {
                  callclass = "bg-success";
                  calldetailclass = "bg-danger ring animated";
                  if (
                    item.Preferred_date === "" ||
                    item.Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      callclass = "bg-danger ring animated";
                    } else {
                      callclass = "bg-success";
                    }
                  }
                } else if (item.state === 1) {
                  callclass = "bg-success";
                  calldetailclass = "bg-success";
                  if (
                    new Date(ncd).getTime() < new Date(calltime).getTime() &&
                    new Date(calltime).getTime() <
                      new Date(item.Preferred_date).getTime()
                  ) {
                    callclass = "bg-success";
                    calldetailclass = "bg-success";
                    return;
                  }
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    callclass = "bg-danger ring animated";
                    calldetailclass = "bg-danger ring animated";
                  }
                  if (
                    new Date(calltime).getTime() >
                    new Date(item.Preferred_date).getTime()
                  ) {
                    callclass = "bg-success";
                    calldetailclass = "bg-success";
                  }
                }

                const HeaderColumn1 = (
                  <div className="d-flex flex-column">
                    <div element_id="Search_HH_hhname" className="name">
                      {item.Nach_flag === "1" ? (
                        <img
                          src={require("../assets/images/nach.png")}
                          alt=""
                          className="nach-img"
                        />
                      ) : (
                        ""
                      )}
                      {item.Lead_Name}
                    </div>
                    <b>
                      <span
                        element_id="Search_HH_Emi"
                        className="justify-content-left"
                      >
                        EMI: Rs.{" "}
                        {parseInt(item.emi).toLocaleString("en-IN")}
                      </span>
                    </b>

                    <span
                      element_id="Search_HH_Location"
                      className="branch_bluetext"
                    >
                      {item.Location_Name}
                    </span>
                  </div>
                );

                const HeaderColumn2 = (
                  <div className="d-flex flex-column">
                    <span element_id="Search_HH_hhid" className="name">
                      {item.HH_ID}
                    </span>
                  </div>
                );

                const HeaderColumn3 = (
                  <div className="d-flex justify-content-around">
                    {process.env.REACT_APP_CSO_QRSMS &&
                    process.env.REACT_APP_CSO_QRSMS !== null ? (
                      process.env.REACT_APP_CSO_QRSMS.toLowerCase().includes(
                        localStorage.getItem("in_username").toLowerCase()
                      ) ? (
                        <button
                        element_id="Search_HH_QRSMS"
                          className="msg_icon_bg mx-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.sendqrsms(
                              item.household_id,
                              item.Household_mobile_no,
                              item.Balance,
                              item.Charges_os,
                              item.emi,
                              item.Loan_os,
                              item.Lead_Name,
                              item.HH_ID
                            );
                          }}
                        >
                          <img
                            element_id="Search_HH_QRSMSImg"
                            src={require("../assets/images/salary.png")}
                            className="msg_icon_img"
                          />
                        </button>
                      ) : (
                        ""
                      )
                    ) : (
                      <PEDiv element_id="Search_HH_CollectionBtn" className="msg_icon_bg mx-1">
                        <button
                          className="msg_icon_bg mx-1"
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   this.sendqrsms(
                          //     item.household_id,
                          //     item.Household_mobile_no,
                          //     item.Balance,
                          //     item.Charges_os,
                          //     item.emi,
                          //     item.Loan_os,
                          //     item.Lead_Name,
                          //     item.HH_ID
                          //   );
                          // }}
                          onClick={() => {
                            this.setState({
                              fliped: false,
                              isOpenCollect: true,
                              payment_method: "",
                              total_amt: "",
                              smsmobile: item.Household_mobile_no,
                              smsread: true,
                              Lead_Name: item.Lead_Name,
                              HH_ID: item.HH_ID,
                              household_id: item.household_id,
                              Charges_os: item.Charges_os,
                              previous_transactions:
                              item.previous_transactions,
                              Balance: item.Balance,
                              serverflag: item.csf,
                              Loan_os: item.Loan_os,
                              details: item
                            });
                          }}
                        >
                          <PEImg
                            element_id="Search_HH_CollectionImg"
                            src={require("../assets/images/salary.png")}
                            className="msg_icon_img"
                          />
                        </button>
                      </PEDiv>
                    )}
                    <PEDiv element_id="Search_HH_CallBtn">
                      <button
                        className={`call_icon_bg mx-1 ${callclass}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          this.handleCallButtonClick(item.household_id, item.HH_ID, item.Household_mobile_no);
                        }}
                        style={{ 
                          background: 'none', 
                          border: 'none', 
                          cursor: 'pointer',
                          padding: '0' // Remove default button padding
                        }}
                      >
                        <PEImg
                          element_id="Search_HH_CallBtnImg"
                          src={require("../assets/images/telephone (2).png")}
                          className="call_icon_img"
                        />
                      </button>
                    </PEDiv>
                    <PEDiv element_id="Search_HH_PtpBtn">
                      <button
                          element_id="Search_HH_PtpBtns"
                          style={{
                            borderRadius: '50%',
                            backgroundColor: '#D27D5C',
                            color: 'white',
                            width: window.innerWidth <= 768 ? '40px' : '50px',
                            height: window.innerWidth <= 768 ? '40px' : '50px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 'none',
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.props.history.push({
                              pathname: "/promisetopay",
                              state: {
                                smsmobile: item.Household_mobile_no,
                                Lead_Name: item.Lead_Name,
                                HH_ID: item.HH_ID,
                                household_id: item.household_id,
                                api_token: api_token,
                              },
                            });
                          }}
                        >
                          PTP+
                      </button>
                    </PEDiv>
                  </div>
                );

                const isMobile = window.innerWidth <= 768;
                const columns = isMobile ? [HeaderColumn2, HeaderColumn3, HeaderColumn1] : [HeaderColumn1, HeaderColumn2, HeaderColumn3];

                return (
                  <div
                    ref={key === this.state.cnames.length - 1 ? (el) => (this.lastItemRef = el) : null}
                  >
                    <PEDiv
                    element_id="Search_HH_hhtiles"
                      className="hh_white_block"
                      key={key}
                      // onClick={() => {
                      //   this.setState({
                      //     //isModalOpen: true,
                      //     isOpenCollect: true,
                      //     payment_method: "",
                      //     total_amt: "",
                      //     Lead_Name: item.Lead_Name,
                      //     HH_ID: item.HH_ID,
                      //     Charges_os: item.Charges_os,
                      //     previous_transactions: item.previous_transactions,
                      //   });
                      // }}
                    >
                      <PEDiv
                        element_id="Search_HH_hhtiles_header"
                      className="name_hh_block"
                    >
                      <div className="name_hh_block w-100">
                        {isMobile ? (
                          <>
                            {/* Mobile view: merge Column2 + Column1 stacked */}
                            <div className="d-flex flex-column">
                              {HeaderColumn2}
                              {HeaderColumn1}
                            </div>

                          {/* Column3 stays as-is */}
                          {HeaderColumn3}
                        </>
                      ) : (
                        <>
                          {/* Desktop view: Column1 | Column2 | Column3 */}
                          {HeaderColumn1}
                          {HeaderColumn2}
                          {HeaderColumn3}
                        </>
                      )}
                    </div>
                    </PEDiv>
                    <br />
                    <div
                      element_id="Seach_HH_CollectionDetail"
                      className="amt_details_block"
                    >
                      <div>
                        <div element_id="Search_HH_hhdemand">
                          <span className="bluetext">Demand</span>
                          <div className="dem_block">
                            Rs.{" "}
                            {(
                              parseInt(item.Demand) +
                              parseInt(item.other_charges_due)
                            ).toLocaleString("en-IN")}
                          </div>
                          <div element_id="Search_HH_DemandSummary">
                            <span className="w-100">
                              <div element_id="Search_HH_hhdemandAmt">
                                <h6>
                                  <small>
                                    Amount:{" "}
                                    {parseInt(item.Demand).toLocaleString(
                                      "en-IN"
                                    )}
                                  </small>
                                </h6>
                              </div>
                              <div element_id="Search_HH_hhdemandCharges">
                                <h6>
                                  <small>
                                    Charges:
                                    {" " +
                                      parseInt(
                                        item.other_charges_due
                                      ).toLocaleString("en-IN")}
                                  </small>
                                </h6>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div element_id="Search_HH_hhcollection">
                        <span className="greentext_sh">Collected</span>

                        <div className="col_block">
                          Rs.{" "}
                          {(
                            parseInt(item.Collected) +
                            parseInt(item.Other_charges_rcvd)
                          ).toLocaleString("en-IN")}
                        </div>
                        <div element_id="Search_HH_Collectionsummary">
                          <span className="w-100">
                            <div element_id="Search_HH_hhCollectionAmt">
                              <h6>
                                <small>
                                  Amount:{" "}
                                  {parseInt(item.Collected).toLocaleString(
                                    "en-IN"
                                  )}
                                </small>
                              </h6>
                            </div>
                            <div element_id="Search_HH_hhCollectionCharges">
                              <h6>
                                <small>
                                  Charges:
                                  {" " +
                                    parseInt(
                                      item.Other_charges_rcvd
                                    ).toLocaleString("en-IN")}
                                </small>
                              </h6>
                            </div>
                          </span>
                        </div>
                      </div>
                      <div element_id="Search_HH_hhbalance">
                        <span className="redtext_sh">Balance</span>
                        <div className="bal_block">
                          Rs.{" "}
                          {(
                            parseInt(item.Balance) + parseInt(item.Charges_os)
                          ).toLocaleString("en-IN")}
                        </div>
                        <div element_id="Search_HH_Balanceonsummary">
                          <span className="w-100">
                            <div element_id="Search_HH_hhBalanceAmt">
                              <h6>
                                <small>
                                  Amount:{" "}
                                  {" " +
                                    parseInt(item.Balance).toLocaleString(
                                      "en-IN"
                                    )}
                                  {/* {parseFloat(item.Balance) -
                                  parseFloat(item.Charges_os) <
                                0
                                  ? "Extra Amount: "
                                  : "Amount: "}
                                {parseFloat(item.Balance) -
                                  parseFloat(item.Charges_os) <
                                0
                                  ? (parseFloat(item.Balance) -
                                      parseFloat(item.Charges_os)) *
                                    parseFloat(-1)
                                  : parseFloat(item.Balance) -
                                    parseFloat(item.Charges_os)} */}
                                </small>
                              </h6>
                            </div>
                            <div element_id="Search_HH_hhBalanceCharges">
                              <h6>
                                <small>
                                  Charges:
                                  {" " +
                                    parseInt(item.Charges_os).toLocaleString(
                                      "en-IN"
                                    )}
                                </small>
                              </h6>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div element_id="Search_HH_LastThreeTransaction">
                      <div className="text-center">
                        <span className="font-weight-bold">
                          Last Three Transaction
                        </span>
                      </div>
                      <div className="d-flex align-items-center my-2">
                        {item.previous_transactions.length > 0 ? (
                          item.previous_transactions.map((transaction) => {
                            const collection_date = new Date(
                              transaction.collection_date
                            );
                            let collection_mode_image = transaction.collection_mode_name;
                            return (
                              <div className="align-items-center w33">
                                <div className="d-flex w-1/4 align-items-center flex-column">
                                  {/* <img src={Calender} /> */}
                                  <span>
                                    {collection_date.toLocaleDateString()}
                                  </span>
                                </div>

                                <div className="d-flex w-1/4 align-items-center flex-column">
                                  {/* <img
                                  className="previous_transaction_img"
                                  src={collection_mode_image}
                                /> */}
                                  {collection_mode_image}
                                </div>
                                <div className="d-flex w-1/4 align-items-center flex-column">
                                  {/* <span className="text-muted ">
                                                Collected Amt
                                              </span> */}
                                  <span className="font-weight-bold text-success f16">
                                    {Number(
                                      transaction.amount_collected
                                    ).toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <span className="pl10">No Previous Transactions</span>
                        )}
                        <br />
                      </div>
                    </div>
                    <PEDiv
                      element_id="Search_HH_LoanDetail"
                      className="amt_bal_block"
                    >
                      {/* <PEButton
                        element_id="Search_HH_LoanDetailBtn"
                        className={`upload_icon_bg mx-1 ${calldetailclass}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.props.history.push({
                            pathname: "/calldetails",
                            state: {
                              api_token: api_token,
                              in_user_id: uid,
                              hh_id: item.HH_ID,
                              Loan_os: item.Loan_os,
                              Charges_os: item.Charges_os,
                              household_id: item.household_id,
                              balance: item.Balance,
                              name: item.Lead_Name,
                              preferred_pay_mode: item.preferred_mode,
                              Preferred_pay_date: item.Preferred_date,
                              nach_flag: item.Nach_flag,
                              effective_designation_id: effective_designation_id,
                            },
                          });
                        }}
                      >
                        <img
                          element_id="Search_HH_LoanDetailImg"
                          src={require("../assets/images/add.png")}
                          className="call_icon_img"
                        />
                      </PEButton> */}
                    </PEDiv>
                  </PEDiv>
                  </div>
                );
                })}
                {this.state.isLoadingMore && (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    padding: '20px',
                    minHeight: '60px'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      border: '4px solid #f3f3f3',
                      borderTop: '4px solid #007bff',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    <style>{`
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                    `}</style>
                  </div>
                )}
                {/* {this.state.hasMore && (
                  <div className="text-center py-2">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => {
                        console.log('manual Load more clicked');
                        this.loadMore();
                      }}
                      disabled={this.state.isLoadingMore}
                    >
                      Load more
                    </button>
                  </div>
                )} */}
                {!this.state.hasMore && this.state.cnames.length > 0 && (
                  <div className="text-center text-muted py-2">No more results</div>
                )}
              </div>
              </>
              )}

              {/* Show "no results" message when search returns empty and not loading */}
              {this.state.cnames.length === 0 && !this.state.isDetailsLoading && this.state.isLoaded && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '80px 20px',
                  color: '#999',
                  fontSize: '16px'
                }}>
                  No results found
                </div>
              )}
              
              {this.state.cnames.length === 0 && this.state.isDetailsLoading && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '80px 20px',
                  gap: '15px'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #3498db',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  <span style={{ color: '#666', fontSize: '16px' }}>Loading households...</span>
                  <style>{`
                    @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                    }
                  `}</style>
                </div>
              )}
            </>
          )}
        </div>

        {/* Separate loaders implemented - details API shows spinner, summary shows skeleton */}
        {/* <PreviousTransactions
          isModalOpen={this.state.isModalOpen}
          handleCancel={this.handleCancelModal}
          handleOk={this.handleOkModal}
          previousTransactions={this.state.previous_transactions}
        /> */}
        {this.state.flag === 0 && (
          <ChatSupportBtn history={this.props.history} />
        )}
        {this.state.showAlternateNumber && (
          <div className="alternate-number-modal">
            <div className="modal-backdrop" onClick={() => this.setState({ showAlternateNumber: false })}></div>
            <div className="modal-content">
              <AlternateNumber
                householdId={this.state.selectedHouseholdId}
                household_number={this.state.hhnumber}
                primaryMobile={this.state.selectedPrimaryMobile}
                onClose={() => this.setState({ showAlternateNumber: false })}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(SearchHousehold);